<template>
    <div class="" style="width:100%;">
        <div v-if="!isLoading">
            <div class="box" style="background-color: #3298dc">
                    <!-- :class="{'has-background-danger' : SelectedJeppesenSummary.finaL_TRANS_STAT ===2,'has-background-success': SelectedJeppesenSummary.finaL_TRANS_STAT===1}"> -->
                <div class="level-item ">
                    <!-- <p style="color: whitesmoke;" class="title is-size-5">Data Transfer Status Of Flights </p>-->
                    <br>
                    <p style="color: whitesmoke;" class="title is-size-5">Netline Flight Data Change History</p>
                </div>
            </div>

            <div v-if="flight.generaL_STAT">
                <div class="box">
                    <div class="level" v-if="flight.generaL_STAT == 0">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="notification is-danger">
                                    <p>Related Jeppesen not found after new Netline update. {{flight.fKeyForNetline}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box">
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <table class="table is-narrow">
                                <thead>
                                <tr>
                                    <th><abbr title=""></abbr></th>
                                    <th align="center"><abbr title="">Netline</abbr></th>
                                    <th align="center"><abbr title="Jeppesen">Jeppesen</abbr></th>
                                    <th><abbr title="Info2"></abbr></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th></th>
                                    <td>{{flight.fKeyForZip}}</td>
                                    <td v-if="EFFjson_data">{{EFFjson_data.poZipMain.KeyForZip}}</td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td>{{flight.std | formatDateNumericWithHour}}</td>
                                    <td v-if="EFFjson_data">{{EFFjson_data.poOFP.STD| formatDateNumericWithHour}}</td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td></td>
                                    <td v-if="EFFjson_data">{{EFFjson_data.poOFP.RemarkStdSta}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td>{{flight.cP1}} {{flight.cP2}} {{flight.cP3}}</td>
                                    <td v-if="EFFjson_data">{{EFFjson_data.poOFP.Captain}}</td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td><b>Leg No:</b> {{flight.leG_NO}}</td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="level-right">
                        <div class="level-item">
                            <button @click="ShowNetlineLastSyncHist()" class="button is-info">
                                <span>Show Netline Last Sync History</span>
                            </button>
                        </div>
                    </div>

                    <div class="level-right">
                        <div class="level-item">
                            <button @click="ShowNetlineChangeHistOriginByDay()" class="button is-info">
                                <span>Show Netline Change History By STDay</span>
                            </button>
                        </div>
                    </div>



                    <div class="level-right">

                        <div class="level-item">
                            <button @click="ShowJetplanWaitingRequestsGridModal()" class="button is-info">
                                <span>Show JetPlan Processes Waiting List</span>
                            </button>
                        </div>

                        <div class="level-item">
                            <div class="field has-addons">
                                <p class="control">

                                        <router-link :to="{ name: 'Schedule', params: {date: this.SearchDate}}" active-class = "is-active">
                                        <button class="button is-info">
                                                 <span class="icon">
                                                  <i class="fas fa-long-arrow-alt-left"></i></span>
                                            <span>Back To Schedule</span>
                                        </button>
                                    </router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="box is-fullwidth">

                <div class="level">
                    <div class="level-left left-main-level">
                        <div class="level-item left-lable">
                            <p style="margin: 16px;" class="title is-size-5">Netline Flights History</p>
                        </div>
                    </div>
                </div>

                <div style="font-size: 15px;" class="request-table-history">

                    <table  class="table is-hoverable is-striped is-fullwidth is-bordered animate__animated animate__slideInUp animate__faster fontsizesmall">
                        <thead style="margin-top: 10px;" class="thead-sticky">
                        <span>
                            <tr>
                                <th style="max-width: 70px;width: 70px; min-width: 70px;">ID</th>
                                <th style="max-width: 95px;width: 95px; min-width: 95px;">LEG_TYPE</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">CREATEDDT</th>
                                <th style="max-width: 200px;width: 150px; min-width: 200px;">FACTION</th>  <!-- 1 DELETE siyah 2 CREATE yeşil 3 UPDATE sarı -->
                                <th style="max-width: 300px;width: 300px; min-width: 300px;">FKeyForZip</th>
                                <th style="max-width: 130px;width: 130px; min-width: 130px;" title="Jeppesen Version Count by Netline Version with JLVT version range." >JCNT - J Range</th>
                                <th style="max-width: 95px;width: 95px; min-width: 90px;">CARRIER</th>
                                <th style="max-width: 55px;width: 55px; min-width: 55px;">STD</th>
                                <th style="max-width: 55px;width: 55px; min-width: 55px;">ATD</th>
                                <th style="max-width: 65px;width: 65px; min-width: 65px;">SDEP</th>
                                <th style="max-width: 65px;width: 65px; min-width: 65px;">ADEP</th>
                                <th style="max-width: 105px;width: 105px; min-width: 105px;">SDEP_ICAO</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">DIS_DT</th>
                                <th style="max-width: 140px;width: 140px; min-width: 140px;">DIV_ARR</th>
                                <th style="max-width: 95px;width: 95px; min-width: 95px;">CALLSIGN</th>
                                <th style="max-width: 75px;width: 75px; min-width: 75px;">ACO</th>
                                <th style="max-width: 52px;width: 52px; min-width: 52px;">CP1</th>
                                <th style="max-width: 90px;width: 90px; min-width: 90px;">CP3</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">LastSync</th>
                                <th style="max-width: 135px;width: 135px; min-width: 135px;">Manuel_Update</th>
                                <th style="max-width: 460px;width: 460px; min-width: 460px;">When_Did</th>
                            </tr>
                            <tr>
                                <th style="max-width: 70px;width: 70px; min-width: 70px;">LEG_NO</th>
                                <th style="max-width: 95px;width: 95px; min-width: 95px;">LEGSTATE</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">MODIFYDATE</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">HIS_DT</th>
                                <th style="max-width: 300px;width: 300px; min-width: 300px;">FKeyForNetline</th>
                                <th style="max-width: 130px;width: 130px; min-width: 130px;">NLVT</th>
                                <th style="max-width: 85px;width: 85px; min-width: 85px;">FNO</th>
                                <th style="max-width: 55px;width: 55px; min-width: 55px;">STA</th>
                                <th style="max-width: 55px;width: 55px; min-width: 55px;">ATA</th>
                                <th style="max-width: 65px;width: 65px; min-width: 65px;">SARR</th>
                                <th style="max-width: 65px;width: 65px; min-width: 65px;">AARR</th>
                                <th style="max-width: 105px;width: 105px; min-width: 105px;">SARR_ICAO</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">DIS_DTYPE</th>
                                <th style="max-width: 140px;width: 140px; min-width: 140px;">DIV_AARR_ICAO</th>
                                <th style="max-width: 95px;width: 95px; min-width: 95px;">SUFFIX</th>
                                <th style="max-width: 75px;width: 75px; min-width: 75px;">ACREG</th>
                                <th style="max-width: 52px;width: 52px; min-width: 52px;">CP2</th>
                                <th style="max-width: 90px;width: 90px; min-width: 90px;">CabinList</th>
                                <th style="max-width: 135px;width: 135px; min-width: 135px;">LastChangeInfo</th>
                                <th style="max-width: 135px;width: 135px; min-width: 135px;">Who_Did</th>
                                <th style="max-width: 460px;width: 460px; min-width: 460px;">Other_Params_Text</th>
                            </tr>
                        </span>

                        </thead>
                        <tbody>
                            <span v-for="(item,index) in NetlineChangeHistoryList" :key="item.id" href="#jwhistory" @click="CloseDetailsOfNetlineFlightHistory(item.OpenCloseDetailsStat,index)">
                                <tr>

                                    <td style="max-width: 70px;width: 70px;">
                                        <span class="borderline">{{item.id}}</span>
                                        <br>
                                        <span class="borderlineSubtd"
                                              :style="{'background-color': ReturnChangeStatColor(item.leG_NO_Change)}">{{item.leG_NO}}</span>
                                    </td>
                                    <td style="max-width: 95px;width: 95px;">
                                        <span class="borderline">{{item.leG_TYPE}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.leG_STATE_Change)}">{{item.leG_STATE}}</span></td>
                                    <td style="max-width: 200px;width: 200px;"><span class="borderline">{{item.createdt|longFormatFromDT}}</span> <br><span
                                            class="borderlineSubtd"> {{item.modifydate|longFormatFromDT}}</span></td>
                                    <td style="max-width: 200px;width: 200px;"><span class="borderline"
                                                                                     :style="{'background-color': FactionStatColorList[item.faction],'color':'gray'}">{{FactionStatEnumType[item.faction]}}</span><br><span
                                            class="borderlineSubtd">{{item.hiS_DT|longFormatFromDT}}</span></td>
                                    <td style="max-width: 300px;width: 300px;"><span class="borderline"
                                                                                     :style="{'background-color': ReturnChangeStatColor(item.fKeyForZip_Change)}">{{item.fKeyForZip}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.fKeyForNetline_Change)}">{{item.fKeyForNetline}}</span></td>
                                    <td style="max-width: 130px;width: 130px;"><span class="borderline"
                                                                                     :style="{'background-color': ReturnChangeStatColor(item.cntJ_Change)}">{{item.cntJ}} - </span>
                                        <span
                                            class="borderline"
                                            :style="{'background-color': ReturnChangeStatColor(item.jlvT_RANGE_Change)}">{{item.jlvT_RANGE}}</span>
                                        <br>
                                        <span class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.nlvt_Change)}">{{item.nlvt}}</span></td>
                                    <td style="max-width: 85px;width: 85px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.carrier_Change)}">{{item.carrier}}</span> <br><span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.fno_Change)}">{{item.fno}}</span> </td>
                                    <td style="max-width: 55px;width: 55px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.std_Change)}">{{item.std | formatDateNumericWithHour}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.sta_Change)}">{{item.sta | formatDateNumericWithHour}}</span></td>
                                    <td style="max-width: 55px;width: 55px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.atd_Change)}">{{item.atd | formatDateNumericWithHour}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.ata_Change)}">{{item.ata | formatDateNumericWithHour}}</span></td>
                                    <td style="max-width: 65px;width: 65px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.sdep_Change)}">{{item.sdep}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.sarr_Change)}">{{item.sarr}}</span></td>
                                    <td style="max-width: 65px;width: 65px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.adep_Change)}">{{item.adep}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.aarr_Change)}">{{item.aarr}}</span></td>
                                    <td style="max-width: 105px;width: 105px;"><span class="borderline"
                                                                                     :style="{'background-color': ReturnChangeStatColor(item.sdeP_ICAO_Change)}">{{item.sdeP_ICAO}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.sarR_ICAO_Change)}">{{item.sarR_ICAO}}</span></td>
                                    <td style="max-width: 200px;width: 200px;"><span class="borderline"
                                                                                     :style="{'background-color': ReturnChangeStatColor(item.diS_DT_Change)}">{{item.diS_DT|longFormatFromDT}} </span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.diS_DTYPE_Change)}"> {{item.diS_DTYPE}}</span> </td>
                                    <td style="max-width: 140px;width: 140px;"><span class="borderline"
                                                                                     :style="{'background-color': ReturnChangeStatColor(item.diV_ARR_Change)}"> {{item.diV_ARR}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.diV_AARR_ICAO_Change)}"> {{item.diV_AARR_ICAO}}</span></td>
                                    <td style="max-width: 95px;width: 95px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.callsign_Change)}">{{item.callsign}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.suffix_Change)}">{{item.suffix}}</span></td>
                                    <td style="max-width: 75px;width: 75px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.aC_OWNER_Change)}">{{item.aC_OWNER}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.acreg_Change)}">{{item.acreg}}</span></td>
                                    <td style="max-width: 52px;width: 52px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.cP1_Change)}">{{item.cP1}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.cP2_Change)}">{{item.cP2}}</span></td>
                                    <td style="max-width: 90px;width: 90px;"><span class="borderline"
                                                                                   :style="{'background-color': ReturnChangeStatColor(item.cP3_Change)}">{{item.cP3}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.cabinList_Change)}">{{item.cabinList}}</span></td>
                                    <td style="max-width: 200px;width: 200px;"><span class="borderline">{{item.lastSync|longFormatFromDT}}</span> <br> <span
                                            class="borderlineSubtd">{{item.lastChangeInfo}}</span></td>
                                    <td style="max-width: 135px;width: 135px;"><span class="borderline"
                                                                                     :style="{'background-color': ReturnChangeStatColor(item.manuelUpdate_Change)}">{{item.manuelUpdate}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.whoDidManual_Change)}">{{item.whoDidManual}}</span></td>
                                    <td style="max-width: 460px;width: 460px;"><span class="borderline"
                                                                                     :style="{'background-color': ReturnChangeStatColor(item.whenDidManual_Change)}">{{item.whenDidManual|longFormatFromDT}}</span> <br> <span
                                            class="borderlineSubtd"
                                            :style="{'background-color': ReturnChangeStatColor(item.otheR_PARAMS_TEXT)}">{{item.otheR_PARAMS_TEXT}}</span></td>
                                </tr>

<!--                                <tr v-if="item.AttachmentHistory!='' && item.SyncOccHistory!='' && item.JeppesenJetplan!=''">-->
<!--                                    <td colspan="21">-->
<!--                                        <div style="float:left;">-->
<!--                                            <div>-->
<!--                                                <span v-if="item.AttachmentHistory!=''">-->
<!--                                                      <button @click="OpenCloseDetailsOfAttachmentHistoric(item.AttachmentHistoricTabShow ,index)" class="button is-info is-small fixed-historic-button">Attachment</button>-->
<!--                                                </span>-->
<!--                                                <span v-if="item.SyncOccHistory!=''">-->
<!--                                                      <button @click="OpenCloseDetailsOfSyncOCCHistoric(item.SyncOCCHisctoricTabShow ,index)" class="button is-info is-small fixed-historic-button">Sync</button>-->
<!--                                                </span>-->
<!--                                                <span v-if="item.JeppesenJetplan!=''">-->
<!--                                                      <button @click="OpenCloseDetailsJeppesenOfHistoric(item.JeppesenHistoricTabShow ,index)" class="button is-info is-small fixed-historic-button">Jeppesen</button>-->
<!--                                                </span>-->


<!--                                                <span v-if="item.AttachmentHistory!=''">-->
<!--                                                      <button @click="ListJsonDataBuilderForModal(item.AttachmentHistory)" class="button is-info is-small fixed-historic-button">Attachment</button>-->
<!--                                                </span>-->
<!--                                                <span v-if="item.SyncOccHistory!=''">-->
<!--                                                      <button @click="ListJsonDataBuilderForModal(item.SyncOccHistory)" class="button is-info is-small fixed-historic-button">Sync</button>-->
<!--                                                </span>-->
<!--                                                <span v-if="item.JeppesenJetplan!=''">-->
<!--                                                      <button @click="ListJsonDataBuilderForModal(item.JeppesenJetplan)" class="button is-info is-small fixed-historic-button">Jeppesen</button>-->
<!--                                                </span>-->



<!--                                            </div>-->

<!--                                            <div>-->
<!--                                                <div v-if="item.AttachmentHistoricTabShow==true">-->
<!--                                                        <span>{{item.AttachmentHistory}}</span>-->
<!--                                                    <br>-->
<!--                                                </div>-->

<!--                                                <div v-if="item.SyncOCCHisctoricTabShow==true">-->
<!--                                                        <span>{{item.SyncOccHistory }}</span>-->
<!--                                                    <br>-->
<!--                                                </div>-->

<!--                                                <div v-if="item.JeppesenHistoricTabShow==true">-->
<!--                                                        <span>{{item.JeppesenJetplan}}</span>-->
<!--                                                    <br>-->
<!--                                                </div>-->
<!--                                            </div>-->

<!--                                        </div>-->
<!--                                    </td>-->
<!--                                </tr>-->

                                <hr>
                            </span>
                        </tbody>
                    </table>
                </div>
            </div>

                <div v-if="flightFolderHistoryWithZip">
                    <!--mainZipDetails-->
                    <div id="jwhistory" class="columns ">
                        <div class="column is-4">
                            <div>
                                <span><b>Jeppesen Version History</b></span><br/>
                                <div class="field has-addons" style="padding-top: 15px">
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="SelectedJLVT" @change = "LoadJLVTlist()">
                                                <option v-for="[key,value] in JLVTDropdownlist" :index="key" :key="key" v-bind:value="key">
                                                    {{key+" | "+ CustomDate(value.endTime)}}  | P. Id:{{value.lasT_PLAN_ID_SUCCEED}}
                                                </option>
                                            </select>
                                            <!--<span>Selected : {{SelectedJLVT}} </span>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="message">
                                <div class="message-header"
                                     :class="{'has-background-grey-light':SelectedJeppesenSummary.unzipStat==0,'has-background-success' : SelectedJeppesenSummary.unzipStat==1 ,'has-background-danger' : SelectedJeppesenSummary.unzipStat==2}">
                                    <div class="level" @click="showHideDivId.mainZipDetails=!showHideDivId.mainZipDetails">
                                        <div class="level-left left-main-level">
                                            <div class="level-item left-lable">
                                                <p class="title is-size-5">Main Zip</p>
                                            </div>
                                            <div class="level-item left-lable">
                                                <p class="title is-size-6">Version :
                                                    {{SelectedJeppesenSummary.jlvt}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="icon"> <font-awesome-icon icon="file-archive" size="2x"/></span>
                                </div>
                                <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                     v-if="showHideDivId.mainZipDetails">
                                    <ul class="list is-full">
                                        <li class="list-item details-label">Start Time :
                                            {{SelectedJeppesenSummary.startTime | formatDateNumericWithHour}}
                                        </li>
                                        <li class="list-item details-label">End Time : {{SelectedJeppesenSummary.endTime
                                            |formatDateNumericWithHour}}
                                        </li>
                                        <li class="list-item details-label">Last Error Message
                                            : {{SelectedJeppesenSummary.unzipLastError }}
                                        </li>
                                        <li class="list-item details-label">Version Count
                                            : {{SelectedJeppesenSummary.jlvt }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="column is-4" style="float: right">
                            <button class="button is-small is-black is-light open-button" type="button"
                                    @click="TryGetIpadPreview()">
                                Last Version Ipad Preview
                            </button>
                            <button class="button is-small is-black open-button" type="button" @click="openOrCloseAllDetails(true)">
                                Open All Details
                            </button>
                            <button class="button is-small is-black is-light close-button" type="button"
                                    @click="openOrCloseAllDetails(false)">Close All Details
                            </button>
                        </div>
                    </div>
                    <div style="max-height: 50px;" class="section has-text-centered">
                    <span class="icon has-text-centered">
                        <font-awesome-icon icon="arrow-down" size="3x" color="#3298dc"/>
                    </span>
                    </div>

                    <div class="box">

                        <div class="columns">
                            <!-- ofpFlightDetails -->
                            <div class="column">
                                <article class="message">

                                    <div class="message-header"
                                         :class="['has-background-danger', SelectedJeppesenSummary.ofpFlightStat==1 && SelectedJeppesenSummary.ofpFlightVersionCount === SelectedJeppesenSummary.jlvt ? 'has-background-success'  : '']"
                                         :title="SelectedJeppesenSummary.ofpFlightStat==1 ? 'No Error':'Error ' + SelectedJeppesenSummary.ofpFlightLastError"
                                         @click="showHideDivId.ofpFlightDetails=!showHideDivId.ofpFlightDetails">

                                        <div class="level">
                                            <div class="level-left left-main-level">
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-5">Ofp Flight</p>
                                                </div>
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-6">Version :
                                                        {{SelectedJeppesenSummary.ofpFlightVersionCount}}</p>
                                                </div>
                                            </div>

                                        </div>
                                        <span class="icon"> <font-awesome-icon icon="database" size="2x" @click="JsonDataBuilderForModal(EFFjson_data.poOFP)"/></span>
                                    </div>

                                    <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                         v-if="showHideDivId.ofpFlightDetails">
                                        <ul class="list is-full">
                                            <li class="list-item details-label">Last Action Date :
                                                {{SelectedJeppesenSummary.ofpLastActionDT | formatDateNumericWithHour}}
                                            </li>
                                            <li class="list-item details-label">Version Count
                                                : {{SelectedJeppesenSummary.ofpFlightVersionCount }}
                                            </li>
                                            <li class="list-item details-label">Last Error Message
                                                : {{SelectedJeppesenSummary.ofpFlightLastError }}
                                            </li>

                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>

                        <div class="columns">
                            <!--Waypoint-->
                            <div class="column">
                                <article class="message">
                                    <div class="message-header"
                                         :class="['has-background-danger', SelectedJeppesenSummary.waypointStat==1 && SelectedJeppesenSummary.waypointVersionCount === SelectedJeppesenSummary.jlvt ? 'has-background-success'  : '']"
                                         :title="SelectedJeppesenSummary.waypointStat==1 ? 'No Error':'Error' + SelectedJeppesenSummary.waypointLastError"
                                         @click="showHideDivId.waypointDetails=!showHideDivId.waypointDetails">
                                        <div class="level">
                                            <div class="level-left left-main-level">
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-5">Waypoint</p>
                                                </div>
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-6">Version :
                                                        {{SelectedJeppesenSummary.waypointVersionCount}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="icon"> <font-awesome-icon icon="database" size="2x" @click="ListJsonDataBuilderForModal(EFFjson_data.poWaypoint.WaypointList)"/></span>
                                    </div>
                                    <div class="message-body details-main animate__animated animate__slideInDown animate__faster" v-if="showHideDivId.waypointDetails">
                                        <ul class="list is-full">
                                            <li class="list-item details-label">Last Action Date :
                                                {{SelectedJeppesenSummary.waypointLastActionDT | formatDateNumericWithHour}}
                                            </li>
                                            <li class="list-item details-label">Version Count
                                                : {{SelectedJeppesenSummary.waypointVersionCount }}
                                            </li>
                                            <li class="list-item details-label">Last Error Message
                                                : {{SelectedJeppesenSummary.waypointLastError }}
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                            <!--Fuel Header-->
                            <div class="column">
                                <article class="message">
                                        <div class="message-header"
                                             :class="['has-background-danger', SelectedJeppesenSummary.fuelHeaderStat==1 && SelectedJeppesenSummary.fuelHeaderVersionCount === SelectedJeppesenSummary.jlvt ? 'has-background-success'  : '']"
                                             :title="SelectedJeppesenSummary.fuelHeaderStat==1 ? 'No Error':'Error' + SelectedJeppesenSummary.fuelHeaderLastError"
                                             @click="showHideDivId.fuelHeaderDetails=!showHideDivId.fuelHeaderDetails">
                                             <div class="level">
                                                <div class="level-left left-main-level">
                                                    <div class="level-item left-lable">
                                                        <p class="title is-size-5">Fuel Header</p>
                                                    </div>
                                                    <div class="level-item left-lable">
                                                        <p class="title is-size-6">Version :
                                                            {{SelectedJeppesenSummary.fuelHeaderVersionCount}}</p>
                                                    </div>
                                                </div>
                                             </div>
                                             <span class="icon"> <font-awesome-icon icon="database" size="2x"
                                                                                   @click="JsonDataBuilderForModal(EFFjson_data.poFuel)"/></span>
                                        </div>
                                        <div class="message-body details-main animate__animated animate__slideInDown animate__faster" v-if="showHideDivId.fuelHeaderDetails">
                                            <ul class="list is-full">
                                                <li class="list-item details-label">Last Action Date :
                                                    {{SelectedJeppesenSummary.fuelHeaderLastActionDT | formatDateNumericWithHour}}
                                                </li>
                                                <li class="list-item details-label">Version Count
                                                    : {{SelectedJeppesenSummary.fuelHeaderVersionCount }}
                                                </li>
                                                <li class="list-item details-label">Last Error Message
                                                    : {{SelectedJeppesenSummary.fuelHeaderLastError }}
                                                </li>
                                            </ul>
                                        </div>
                                </article>
                            </div>
                        </div>
                    </div>

                    <div class="box">
                        <div class="columns">
                            <!--ofpFlightReleasePdf-->
                            <div class="column">
                                <article class="message">
                                    <div class="message-header"
                                         :class="['has-background-danger', SelectedJeppesenSummary.ofpFlightReleasePdfStat == 1 && SelectedJeppesenSummary.ofpFlightReleasePdfVersionCount === SelectedJeppesenSummary.jlvt ? 'has-background-success'  : '']"
                                         :title="SelectedJeppesenSummary.ofpFlightReleasePdfStat == 1 ? 'No Error':'Error' + SelectedJeppesenSummary.ofpFlightReleasePdfLastError">
                                        <div class="level"
                                             @click="showHideDivId.ofpFlightReleasePdf=!showHideDivId.ofpFlightReleasePdf">
                                            <div class="level-left left-main-level">
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-5">Ofp Flight Release Pdf</p>
                                                </div>
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-6">Version :
                                                        {{SelectedJeppesenSummary.ofpFlightReleasePdfVersionCount}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <span class="icon"> <font-awesome-icon icon="file-pdf" @click="showAttachmentReleaseModal()"
                                                                               size="2x"/></span>
                                    </div>
                                    <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                         v-if="showHideDivId.ofpFlightReleasePdf">
                                        <ul class="list is-full">
                                            <li class="list-item details-label">Last Action Date :
                                                {{SelectedJeppesenSummary.ofpFlightReleasePdfLastActionDT |
                                                formatDateNumericWithHour}}
                                            </li>
                                            <li class="list-item details-label">Version Count
                                                : {{SelectedJeppesenSummary.ofpFlightReleasePdfVersionCount }}
                                            </li>
                                            <li class="list-item details-label">Last Error Message
                                                : {{SelectedJeppesenSummary.ofpFlightReleasePdfLastError }}
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>

                        <div class = "columns">

            <!--                Weight Header-->
                            <div class="column">
                                <article class="message">
                                    <div class="message-header"
                                         :class="['has-background-danger', SelectedJeppesenSummary.weightHeaderStat==1 && SelectedJeppesenSummary.weightHeaderVersionCount === SelectedJeppesenSummary.jlvt ? 'has-background-success'  : '']"
                                         :title="SelectedJeppesenSummary.weightHeaderStat==1 ? 'No Error':'Error' + SelectedJeppesenSummary.weightHeaderLastError"
                                         @click="showHideDivId.weightHeaderDetails=!showHideDivId.weightHeaderDetails">
                                        <div class="level">
                                            <div class="level-left left-main-level">
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-5">Weight Header</p>
                                                </div>
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-6">Version :
                                                        {{SelectedJeppesenSummary.weightHeaderVersionCount}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="icon"> <font-awesome-icon icon="database" size="2x"/>
                                        </span>
                                    </div>
                                    <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                         v-if="showHideDivId.weightHeaderDetails">
                                        <ul class="list is-full">
                                            <li class="list-item details-label">Last Action Date :
                                                {{SelectedJeppesenSummary.weightHeaderLastActionDT | formatDateNumericWithHour}}
                                            </li>
                                            <li class="list-item details-label">Version Count
                                                : {{SelectedJeppesenSummary.weightHeaderVersionCount }}
                                            </li>
                                            <li class="list-item details-label">Last Error Message
                                                : {{SelectedJeppesenSummary.weightHeaderLastError }}
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>

                            <!-- meteoPdfDetails-->
                            <div class="column">
                                <article class="message">
                                    <div class="message-header"
                                         :class="['has-background-danger', SelectedJeppesenSummary.meteoPdfStat==1 && SelectedJeppesenSummary.meteoPdfVersionCount === SelectedJeppesenSummary.jlvt ? 'has-background-success'  : '']"
                                         :title="SelectedJeppesenSummary.meteoPdfStat==1 ? 'No Error':'Error' + SelectedJeppesenSummary.meteoPdfLastError"
                                         @click="showHideDivId.meteoPdfDetails=!showHideDivId.meteoPdfDetails">
                                        <div class="level">
                                            <div class="level-left left-main-level">
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-5">Meteo</p>
                                                </div>
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-6">Version :
                                                        {{SelectedJeppesenSummary.meteoPdfVersionCount}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="icon"> <font-awesome-icon icon="database" size="2x"
                                                                               @click="JsonDataBuilderForModal(EFFjson_data.poMeteo)"/></span>
                                    </div>
                                    <!--meteoPdfDetails-->
                                    <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                         v-if="showHideDivId.meteoPdfDetails">
                                        <ul class="list is-full">
                                            <li class="list-item details-label">Last Action Date :
                                                {{SelectedJeppesenSummary.meteoPdfLastActionDT | formatDateNumericWithHour}}
                                            </li>
                                            <li class="list-item details-label">Version Count
                                                : {{SelectedJeppesenSummary.meteoPdfVersionCount }}
                                            </li>
                                            <li class="list-item details-label">Last Error Message
                                                : {{SelectedJeppesenSummary.meteoPdfLastError }}
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>

                            <!--notamPdfDetails-->
                            <div class="column">
                                <article class="message">
                                    <div class="message-header"
                                         :class="['has-background-danger', SelectedJeppesenSummary.notamPdfStat==1 && SelectedJeppesenSummary.notamPdfVersionCount === SelectedJeppesenSummary.jlvt ? 'has-background-success'  : '']"
                                         :title="SelectedJeppesenSummary.notamPdfStat==1 ? 'No Error':'Error' + SelectedJeppesenSummary.notamPdfLastError">
                                        <div class="level">
                                            <div class="level-left left-main-level">
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-5">Notam</p>
                                                </div>
                                                <div class="level-item left-lable">
                                                    <p class="title is-size-6">Version :
                                                        {{SelectedJeppesenSummary.notamPdfVersionCount}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="icon"> <font-awesome-icon icon="database" size="2x"
                                                                               @click="ListJsonDataBuilderForModal(EFFjson_data.poNotam.NotamList)"/></span>
                                    </div>
                                    <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                         v-if="showHideDivId.notamPdfDetails">
                                        <ul class="list is-full">
                                            <li class="list-item details-label">Last Action Date :
                                                {{SelectedJeppesenSummary.notamPdfLastActionDT | formatDateNumericWithHour}}
                                            </li>
                                            <li class="list-item details-label">Version Count
                                                : {{SelectedJeppesenSummary.notamPdfVersionCount }}
                                            </li>
                                            <li class="list-item details-label">Last Error Message
                                                : {{SelectedJeppesenSummary.notamPdfLastError }}
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>

                    <!-- AllWebStats ve Succesfulstat olarak ikili tab yapman gerekir. -->
                    <div class="tabs is-centered">
                        <ul>
                            <li :class="showAllWebStats ? 'is-active':''" @click="GelAllWebStats()"><a>All Web Stats</a></li>
                            <li :class="showSuccesfulWebStats ? 'is-active':''" @click="GetSuccesfullWebStats()"><a>Successful Web Stats</a></li>
                        </ul>
                    </div>
                    <div class="box">

                    <div class="columns">
                            <div class="column">
                                <div class="level">
                                    <div class="level-item">
                                            <button v-if="forceManuallyControl == 0" @click="ForceUpdate(1)" class="button is-info">
                                                <span>Jetplan Force Manually</span>
                                            </button>

                                            <button v-if="forceManuallyControl == 1" @click="ForceUpdate(0)" class="button is-danger">
                                                <span>Cancel Force Manually</span>
                                            </button>
                                    </div>
                                    <div class="level-right">
                                            <div>
                                                 <p style="padding-right: 75px; font-size: larger">Jetplanner History by this session :</p><p v-if="SelectedWLVT == 0" style="color: red">No Jetplan version for Jeppesen ({{SelectedJLVT}}) version </p>
                                            </div>
                                            <!-- <p>test {{this.WLVTDropdownlistFilteredIsSuccededs.length}} || {{this.WLVTDropdownlistFilteredIsSuccededs.size}}</p>-->
                                            <div class="select">
                                                <!-- (showAllWebStats===true)?this.WLVTDropdownlist:this.WLVTDropdownlist.filter(x=>x.finaL_TRANS_STAT===1) -->

                                                <div v-if="showAllWebStats===true">
                                                    <select v-model="SelectedWLVT" @change="loadWLVT()">
                                                        <option v-for="[key,value] in this.WLVTDropdownlist" :index="key" :key="key" v-bind:value="key">
                                                            <p v-if="key==0">No Data</p>
                                                            <p v-else>{{key+" / "+ CustomDate(value.endTime) }}</p>
                                                        </option>
                                                    </select>
                                                </div>

                                                <div v-if="showAllWebStats===false">

                                                    <div v-if="this.WLVTDropdownlistFilteredIsSuccededs.size == 0">
                                                        <select name="" id="">
                                                            <option selected>
                                                                <p>No Data</p>
                                                            </option>s
                                                        </select>
                                                    </div>
                                                    <div v-else>
                                                        <select v-model="SelectedWLVT" @change="loadWLVT()">
<!--                                                        [...this.WLVTDropdownlist].filter(([k, v]) => v.finaL_TRANS_STAT===1 && k==k)-->
<!--                                                        <option selected><p>{{ this.WLVTDropdownlistFilteredIsSuccededs.get(0)  }} test</p> </option>-->
<!--                                                        <option selected><p>{{ [...this.WLVTDropdownlistFilteredIsSuccededs].filter(([k, v]) => v==v && k===0).wlvt+" / "+ CustomDate([...this.WLVTDropdownlistFilteredIsSuccededs].filter(([k, v]) => v==v && k===0).endTime) }}</p> </option>-->

                                                            <option style="" v-for="[key,value] in this.WLVTDropdownlistFilteredIsSuccededs" :index="key" :key="key" v-bind:value="key">
<!--                                                                :selected="option == 'this.WLVTDropdownlistFilteredIsSuccededs[0]'"-->
<!--                                                                <p v-if="key==0">No Data</p>-->

                                                                <p>{{key+" / "+ CustomDate(value.endTime) }}</p>
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                              </div>
                            </div>
                        </div>



                    <div class="columns">
                        <!--Weather Chart-->
                        <div class="column">
                            <article class="message">
                                <div class="message-header"
                                     :class="['has-background-danger', SelectedJetPlanSummary.weatherStat==1 && SelectedJetPlanSummary.weatherVersionCount === SelectedJetPlanSummary.wlvt ? 'has-background-success'  : '']"
                                     :title="SelectedJetPlanSummary.weatherStat==1 ? 'No Error':'Error' + SelectedJetPlanSummary.weatherLastError"
                                     @click="showHideDivId.weatherDetails=!showHideDivId.weatherDetails">
                                    <div class="level">
                                        <div class="level-left left-main-level">
                                            <div class="level-item left-lable">
                                                <p class="title is-size-5">Weather</p>
                                            </div>
                                            <div class="level-item left-lable">
                                                <p class="title is-size-6">Version :
                                                    {{SelectedJetPlanSummary.weatherVersionCount}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="icon"> <font-awesome-icon icon="file-pdf" size="2x" @click="showWeatherChartModal()"/></span>
                                </div>
                                <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                     v-if="showHideDivId.weatherDetails">
                                    <ul class="list is-full">
                                        <li class="list-item details-label">Last Action Date :
                                            {{SelectedJetPlanSummary.weatherLastActionDT | formatDateNumericWithHour}}
                                        </li>
                                        <li class="list-item details-label">Version Count
                                            : {{SelectedJetPlanSummary.weatherVersionCount }}
                                        </li>
                                        <li class="list-item details-label">Last Error Message
                                            : {{SelectedJetPlanSummary.weatherLastError }}
                                        </li>
                                    </ul>
                                </div>
                            </article>
                        </div>
                        <!--weatherWebDetails-->
                        <div class="column">
                            <article class="message">
                                <div class="message-header"
                                     :class="['has-background-danger', SelectedJetPlanSummary.weatherWebStat==1 && SelectedJetPlanSummary.weatherWebVersionCount === SelectedJetPlanSummary.wlvt ? 'has-background-success'  : '']"
                                     :title="SelectedJetPlanSummary.weatherWebStat==1 ? 'No Error':'Error' + SelectedJetPlanSummary.weatherWebLastError"
                                     @click="showHideDivId.weatherWebDetails=!showHideDivId.weatherWebDetails">
                                    <div class="level">
                                        <div class="level-left left-main-level">
                                            <div class="level-item left-lable">
                                                <p class="title is-size-5">Weather Web</p>
                                            </div>
                                            <div class="level-item left-lable">
                                                <p class="title is-size-6">Version :
                                                    {{SelectedJetPlanSummary.weatherWebVersionCount}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="icon"> <font-awesome-icon icon="database" size="2x"  @click="showWeatherWebModal()"/></span>   <!--goToWeatherWebPdf()-->
                                </div>
                                <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                     v-if="showHideDivId.weatherWebDetails">
                                    <ul class="list is-full">
                                        <li class="list-item details-label">Last Action Date :
                                            {{SelectedJetPlanSummary.weatherWebLastActionDT | formatDateNumericWithHour}}
                                        </li>
                                        <li class="list-item details-label">Version Count
                                            : {{SelectedJetPlanSummary.weatherWebVersionCount }}
                                        </li>
                                        <li class="list-item details-label">Last Error Message
                                            : {{SelectedJetPlanSummary.weatherWebLastError }}
                                        </li>
                                    </ul>
                                </div>
                            </article>
                        </div>
                        <!--Notam Web-->
                        <div class="column">
                            <article class="message">
                                <div class="message-header"
                                     :class="['has-background-danger', SelectedJetPlanSummary.notamWebStat==1 && SelectedJetPlanSummary.notamWebVersionCount === SelectedJetPlanSummary.wlvt ? 'has-background-success'  : '']"
                                     :title="SelectedJetPlanSummary.notamWebStat==1 ? 'No Error':'Error' + SelectedJetPlanSummary.notamWebLastError"
                                     @click="showHideDivId.notamWebDetails=!showHideDivId.notamWebDetails">
                                    <div class="level">
                                        <div class="level-left left-main-level">
                                            <div class="level-item left-lable">
                                                <p class="title is-size-5">Notam Web</p>
                                            </div>
                                            <div class="level-item left-lable">
                                                <p class="title is-size-6">Version :
                                                    {{SelectedJetPlanSummary.notamWebVersionCount}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="icon"> <font-awesome-icon icon="database" size="2x"
                                                                           @click="showNotamWebModal()"/></span>
                                </div>
                                <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                     v-if="showHideDivId.notamWebDetails">
                                    <ul class="list is-full">
                                        <li class="list-item details-label">Last Action Date :
                                            {{SelectedJetPlanSummary.notamWebLastActionDT | formatDateNumericWithHour}}
                                        </li>
                                        <li class="list-item details-label">Version Count
                                            : {{SelectedJetPlanSummary.notamWebVersionCount}}
                                        </li>
                                        <li class="list-item details-label">Last Error Message
                                            : {{SelectedJetPlanSummary.notamWebLastError}}
                                        </li>
                                    </ul>
                                </div>
                            </article>
                        </div>
                        <!--Raim Prediction-->
                        <div class="column">
                            <article class="message">
                                <div class="message-header"
                                     :class="['has-background-danger', SelectedJetPlanSummary.raimPredictionStat == 1 && SelectedJetPlanSummary.raimPredictionVersionCount === SelectedJetPlanSummary.wlvt ? 'has-background-success'  : '']"
                                     :title="SelectedJetPlanSummary.raimPredictionStat == 1 ? 'No Error':'Error' + SelectedJetPlanSummary.raimPredictionLastError"
                                     @click="showHideDivId.raimPrediction=!showHideDivId.raimPrediction">
                                    <div class="level">
                                        <div class="level-left left-main-level">
                                            <div class="level-item left-lable">
                                                <p class="title is-size-5">Raim Prediction</p>
                                            </div>
                                            <div class="level-item left-lable">
                                                <p class="title is-size-6">Version :
                                                    {{SelectedJetPlanSummary.raimPredictionVersionCount}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="icon"> <font-awesome-icon icon="database" size="2x"
                                                                           @click="GetHtmlDataR()"/></span>
                                </div>
                                <div class="message-body details-main animate__animated animate__slideInDown animate__faster"
                                     v-if="showHideDivId.raimPrediction">
                                    <ul class="list is-full">
                                        <li class="list-item details-label">Last Action Date :
                                            {{SelectedJetPlanSummary.raimPredictionLastActionDT |
                                            formatDateNumericWithHour}}
                                        </li>
                                        <li class="list-item details-label">Version Count
                                            : {{SelectedJetPlanSummary.raimPredictionVersionCount }}
                                        </li>
                                        <li class="list-item details-label">Last Error Message
                                            : {{SelectedJetPlanSummary.raimPredictionLastError }}
                                        </li>
                                    </ul>
                                </div>
                            </article>
                        </div>

                    </div>
                </div>

                </div>

                <div v-else class="container">
                    <div class="notification is-danger">
                        <p class="title is-size-4 ">No jeppesen zip file processed.</p>
                    </div>
                </div>


            <div class="modal has-text-centered" id="NetlineSyncSummary" :class="{'is-active':netlineModal}">
                <div class="modal-background" @click="netlineModal=false"></div>
                <div class="modal-card modal-card-size bg-default">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Netline Sync Summary</p>
                        <download-excel :data="NetlinesyncHist" title="Download Excel" style="cursor: pointer">
                        <!--  <p style="margin: 10px;" class="title is-size-5">Excel Download</p>  -->
                            <button class="btn-excel mr-10p">Excel Download</button>

                        </download-excel>
                        <button class="btn-refresh mr-10p"  @click="JustGetNetlinesyncSummary()"><font-awesome-icon icon="sync-alt"></font-awesome-icon></button>

                        <button class="delete" @click="netlineModal=false"></button>
                    </header>
                    <section class="modal-card-body">
                        <div class="tableFixHead column box bg" style="overflow-x:auto;">
                            <table class="table is-bordered" style="overflow-x:auto">
                                <thead>
                                <tr>
                                    <th class="modal-netline-th">CreateDT</th>
                                    <th class="modal-netline-th">WhenSynedToOCCSystem</th>
                                    <th class="modal-netline-th">LastCheck</th>
                                    <th class="modal-netline-th">NoChangeCount</th>
                                    <th class="modal-netline-th">DataRangeDay</th>
                                    <th class="modal-netline-th">DataRangeStart</th>
                                    <th class="modal-netline-th">DataRangeFinish</th>
                                    <th class="modal-netline-th">TotalRecord</th>
                                    <th class="modal-netline-th">DelCnt</th>
                                    <th class="modal-netline-th">CrtCnt</th>
                                    <th class="modal-netline-th">UpdCnt</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template>
                                    <tr v-for="data in NetlinesyncHist" :key="data.ID">
                                        <td>{{ data.createDT | longFormatDateFromString }}</td>
                                        <td>{{ data.whenSynedToOCCSystem | longFormatDateFromString }}</td>
                                        <td>{{ data.lastCheck | longFormatDateFromString }}</td>
                                        <td>{{ data.noChangeCount }}</td>
                                        <td>{{ data.dataRangeDay | longFormatDateFromString }}</td>
                                        <td>{{ data.dataRangeStart | longFormatDateFromString }}</td>
                                        <td>{{ data.dataRangeFinish | longFormatDateFromString }}</td>
                                        <td>{{ data.totalRecord }}</td>
                                        <td>{{ data.delCnt }}</td>
                                        <td>{{ data.crtCnt }}</td>
                                        <td>{{ data.updCnt }}</td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
            </div>

            <div class="modal" :class="{'is-active':netlineChangeHistoryOriginModal}">
                <div class="modal-background" @click="netlineChangeHistoryOriginModal=false"></div>
                <div class="modal-content   animate__animated animate__zoomIn animate__faster" style="width: 99%;height: 100%">
                    <div class="notification is-white" style="width: 100%;height: 100%;">
                        <div class="box">
                            <div class="level">
                                <div class="level-left">
                                    <p style="margin: 10px;" class="title is-size-5">Netline Change History Origin</p>
                                </div>
                                <div class="level-left">
                                    <download-excel :data="netlineChangeHistoryOrigin" title="Download Excel" style="cursor: pointer">
<!--                                        <p style="margin: 10px;" class="title is-size-5">Excel Download</p>-->
                                        <button class="btn-excel mr-10p">Excel Download</button>
                                    </download-excel>
                                    <button style="background-color: red" class="delete" @click="netlineChangeHistoryOriginModal = false"></button>
                                </div>
                            </div>
                        </div>
                        <div class="" style="margin-top: 10px">
                            <div class="box is-fullwidth" style="overflow: auto; padding: 0.5rem">

                                <div style="font-size: 15px;" class="request-table-history">

                                    <table  class="table is-hoverable is-striped is-fullwidth is-bordered animate__animated animate__slideInUp animate__faster fontsizesmall" style="min-height: 300px">
                                        <thead style="margin-top: 10px;" class="thead-sticky">
                                        <span>
                            <tr>
                                <th style="max-width: 70px;width: 70px; min-width: 70px;">ID</th>
                                <th style="max-width: 95px;width: 95px; min-width: 95px;">LEG_TYPE</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">CREATEDDT</th>
                                <th style="max-width: 200px;width: 150px; min-width: 200px;">FACTION</th>  <!-- 1 DELETE siyah 2 CREATE yeşil 3 UPDATE sarı -->
                                <th style="max-width: 300px;width: 300px; min-width: 300px;">FKeyForZip</th>
                                <th style="max-width: 130px;width: 130px; min-width: 130px;" title="Jeppesen Version Count by Netline Version with JLVT version range." >JCNT - J Range</th>
                                <th style="max-width: 95px;width: 95px; min-width: 90px;">CARRIER</th>
                                <th style="max-width: 55px;width: 55px; min-width: 55px;">STD</th>
                                <th style="max-width: 55px;width: 55px; min-width: 55px;">ATD</th>
                                <th style="max-width: 65px;width: 65px; min-width: 65px;">SDEP</th>
                                <th style="max-width: 65px;width: 65px; min-width: 65px;">ADEP</th>
                                <th style="max-width: 105px;width: 105px; min-width: 105px;">SDEP_ICAO</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">DIS_DT</th>
                                <th style="max-width: 140px;width: 140px; min-width: 140px;">DIV_ARR</th>
                                <th style="max-width: 95px;width: 95px; min-width: 95px;">CALLSIGN</th>
                                <th style="max-width: 75px;width: 75px; min-width: 75px;">ACO</th>
                                <th style="max-width: 52px;width: 52px; min-width: 52px;">CP1</th>
                                <th style="max-width: 90px;width: 90px; min-width: 90px;">CP3</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">LastSync</th>
                                <th style="max-width: 135px;width: 135px; min-width: 135px;">Manuel_Update</th>
                                <th style="max-width: 460px;width: 460px; min-width: 460px;">When_Did</th>
                            </tr>
                            <tr>
                                <th style="max-width: 70px;width: 70px; min-width: 70px;">LEG_NO</th>
                                <th style="max-width: 95px;width: 95px; min-width: 95px;">LEGSTATE</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">MODIFYDATE</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">HIS_DT</th>
                                <th style="max-width: 300px;width: 300px; min-width: 300px;">FKeyForNetline</th>
                                <th style="max-width: 130px;width: 130px; min-width: 130px;">NLVT</th>
                                <th style="max-width: 85px;width: 85px; min-width: 85px;">FNO</th>
                                <th style="max-width: 55px;width: 55px; min-width: 55px;">STA</th>
                                <th style="max-width: 55px;width: 55px; min-width: 55px;">ATA</th>
                                <th style="max-width: 65px;width: 65px; min-width: 65px;">SARR</th>
                                <th style="max-width: 65px;width: 65px; min-width: 65px;">AARR</th>
                                <th style="max-width: 105px;width: 105px; min-width: 105px;">SARR_ICAO</th>
                                <th style="max-width: 200px;width: 200px; min-width: 200px;">DIS_DTYPE</th>
                                <th style="max-width: 140px;width: 140px; min-width: 140px;">DIV_AARR_ICAO</th>
                                <th style="max-width: 95px;width: 95px; min-width: 95px;">SUFFIX</th>
                                <th style="max-width: 75px;width: 75px; min-width: 75px;">ACREG</th>
                                <th style="max-width: 52px;width: 52px; min-width: 52px;">CP2</th>
                                <th style="max-width: 90px;width: 90px; min-width: 90px;">CabinList</th>
                                <th style="max-width: 135px;width: 135px; min-width: 135px;">LastChangeInfo</th>
                                <th style="max-width: 135px;width: 135px; min-width: 135px;">Who_Did</th>
                                <th style="max-width: 460px;width: 460px; min-width: 460px;">Other_Params_Text</th>
                            </tr>
                        </span>

                                        </thead>
                                        <tbody>
                                        <span v-for="(item,index) in netlineChangeHistoryOrigin" :key="index">
                                <tr>

                                    <td style="max-width: 70px;width: 70px;">
                                        <span class="borderline">{{item.id}}</span>
                                        <br>
                                        <span class="borderlineSubtd">{{item.leG_NO}}</span>
                                    </td>
                                    <td style="max-width: 95px;width: 95px;">
                                        <span class="borderline">{{item.leG_TYPE}}</span> <br> <span
                                            class="borderlineSubtd">{{item.leG_STATE}}</span></td>
                                    <td style="max-width: 200px;width: 200px;"><span class="borderline">{{item.createdt|longFormatFromDT}}</span> <br><span
                                            class="borderlineSubtd"> {{item.modifydate|longFormatFromDT}}</span></td>
                                    <td style="max-width: 200px;width: 200px;"><span class="borderline "   :style="{'background-color': FactionStatColorList[item.faction],'color':'gray'}">{{FactionStatEnumType[item.faction]}}>{{item.faction}}</span><br><span
                                            class="borderlineSubtd">{{item.hiS_DT|longFormatFromDT}}</span></td>
                                    <td style="max-width: 300px;width: 300px;"><span class="borderline">{{item.fKeyForZip}}</span> <br> <span
                                            class="borderlineSubtd">{{item.fKeyForNetline}}</span></td>
                                    <td style="max-width: 130px;width: 130px;"><span class="borderline">{{item.cntJ}} - </span>
                                        <span
                                                class="borderline">{{item.cntJ}}</span>
                                        <br>
                                        <span class="borderlineSubtd">{{item.nlvt}}</span></td>
                                    <td style="max-width: 85px;width: 85px;"><span class="borderline">{{item.carrier}}</span> <br><span
                                            class="borderlineSubtd">{{item.fno}}</span> </td>
                                    <td style="max-width: 55px;width: 55px;"><span class="borderline">{{item.std | formatDateNumericWithHour}}</span> <br> <span
                                            class="borderlineSubtd">{{item.sta | formatDateNumericWithHour}}</span></td>
                                    <td style="max-width: 55px;width: 55px;"><span class="borderline">{{item.atd | formatDateNumericWithHour}}</span> <br> <span
                                            class="borderlineSubtd">{{item.ata | formatDateNumericWithHour}}</span></td>
                                    <td style="max-width: 65px;width: 65px;"><span class="borderline">{{item.sdep}}</span> <br> <span
                                            class="borderlineSubtd">{{item.sarr}}</span></td>
                                    <td style="max-width: 65px;width: 65px;"><span class="borderline">{{item.adep}}</span> <br> <span
                                            class="borderlineSubtd">{{item.aarr}}</span></td>
                                    <td style="max-width: 105px;width: 105px;"><span class="borderline">{{item.sdeP_ICAO}}</span> <br> <span
                                            class="borderlineSubtd">{{item.sarR_ICAO}}</span></td>
                                    <td style="max-width: 200px;width: 200px;"><span class="borderline">{{item.diS_DT|longFormatFromDT}} </span> <br> <span
                                            class="borderlineSubtd"> {{item.diS_DTYPE}}</span> </td>
                                    <td style="max-width: 140px;width: 140px;"><span class="borderline"> {{item.diV_ARR}}</span> <br> <span
                                            class="borderlineSubtd"> {{item.diV_AARR_ICAO}}</span></td>
                                    <td style="max-width: 95px;width: 95px;"><span class="borderline">{{item.callsign}}</span> <br> <span
                                            class="borderlineSubtd">{{item.suffix}}</span></td>
                                    <td style="max-width: 75px;width: 75px;"><span class="borderline">{{item.aC_OWNER}}</span> <br> <span
                                            class="borderlineSubtd">{{item.acreg}}</span></td>
                                    <td style="max-width: 52px;width: 52px;"><span class="borderline">{{item.cP1}}</span> <br> <span
                                            class="borderlineSubtd">{{item.cP2}}</span></td>
                                    <td style="max-width: 90px;width: 90px;"><span class="borderline">{{item.cP3}}</span> <br> <span
                                            class="borderlineSubtd">{{item.cabinList}}</span></td>
                                    <td style="max-width: 200px;width: 200px;"><span class="borderline">{{item.lastSync|longFormatFromDT}}</span> <br> <span
                                            class="borderlineSubtd">{{item.lastChangeInfo}}</span></td>
                                    <td style="max-width: 135px;width: 135px;"><span class="borderline">{{item.manuelUpdate}}</span> <br> <span
                                            class="borderlineSubtd">{{item.whoDidManual}}</span></td>
                                    <td style="max-width: 460px;width: 460px;"><span class="borderline">{{item.whenDidManual|longFormatFromDT}}</span> <br> <span
                                            class="borderlineSubtd">{{item.otheR_PARAMS_TEXT}}</span></td>
                                </tr>

                                            <!--                                <tr v-if="item.AttachmentHistory!='' && item.SyncOccHistory!='' && item.JeppesenJetplan!=''">-->
                                            <!--                                    <td colspan="21">-->
                                            <!--                                        <div style="float:left;">-->
                                            <!--                                            <div>-->
                                            <!--                                                <span v-if="item.AttachmentHistory!=''">-->
                                            <!--                                                      <button @click="OpenCloseDetailsOfAttachmentHistoric(item.AttachmentHistoricTabShow ,index)" class="button is-info is-small fixed-historic-button">Attachment</button>-->
                                            <!--                                                </span>-->
                                            <!--                                                <span v-if="item.SyncOccHistory!=''">-->
                                            <!--                                                      <button @click="OpenCloseDetailsOfSyncOCCHistoric(item.SyncOCCHisctoricTabShow ,index)" class="button is-info is-small fixed-historic-button">Sync</button>-->
                                            <!--                                                </span>-->
                                            <!--                                                <span v-if="item.JeppesenJetplan!=''">-->
                                            <!--                                                      <button @click="OpenCloseDetailsJeppesenOfHistoric(item.JeppesenHistoricTabShow ,index)" class="button is-info is-small fixed-historic-button">Jeppesen</button>-->
                                            <!--                                                </span>-->


                                            <!--                                                <span v-if="item.AttachmentHistory!=''">-->
                                            <!--                                                      <button @click="ListJsonDataBuilderForModal(item.AttachmentHistory)" class="button is-info is-small fixed-historic-button">Attachment</button>-->
                                            <!--                                                </span>-->
                                            <!--                                                <span v-if="item.SyncOccHistory!=''">-->
                                            <!--                                                      <button @click="ListJsonDataBuilderForModal(item.SyncOccHistory)" class="button is-info is-small fixed-historic-button">Sync</button>-->
                                            <!--                                                </span>-->
                                            <!--                                                <span v-if="item.JeppesenJetplan!=''">-->
                                            <!--                                                      <button @click="ListJsonDataBuilderForModal(item.JeppesenJetplan)" class="button is-info is-small fixed-historic-button">Jeppesen</button>-->
                                            <!--                                                </span>-->



                                            <!--                                            </div>-->

                                            <!--                                            <div>-->
                                            <!--                                                <div v-if="item.AttachmentHistoricTabShow==true">-->
                                            <!--                                                        <span>{{item.AttachmentHistory}}</span>-->
                                            <!--                                                    <br>-->
                                            <!--                                                </div>-->

                                            <!--                                                <div v-if="item.SyncOCCHisctoricTabShow==true">-->
                                            <!--                                                        <span>{{item.SyncOccHistory }}</span>-->
                                            <!--                                                    <br>-->
                                            <!--                                                </div>-->

                                            <!--                                                <div v-if="item.JeppesenHistoricTabShow==true">-->
                                            <!--                                                        <span>{{item.JeppesenJetplan}}</span>-->
                                            <!--                                                    <br>-->
                                            <!--                                                </div>-->
                                            <!--                                            </div>-->

                                            <!--                                        </div>-->
                                            <!--                                    </td>-->
                                            <!--                                </tr>-->

                                <hr>
                            </span>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ShowAttachmentModal
                    :isActiveAttachmentModal='isActiveAttachmentModal'
                    :activeUrl="attachmentActiveUrl"
                    :activeFKey="attachmentActiveFKey"
                    @closeAttachmentModal="closeAttachmentModal"
            />

            <JetplanWaitingRequestsGridModal
                    :isActiveJetplanWaitingRequestsGridModal = 'isActiveJetplanWaitingRequestsGridModal'
                    :waitinglistBridge  = "WaitingList"
                    @closeJetplanWaitingRequestsGridModal = "closeJetplanWaitingRequestsGridModal"
            />

            <object-rendering
                    :isActiveObjectModal = 'isActiveObjectModal'
                    :object = "SelectedJsonDataForModal"
                    @closeObjectModal = "closeObjectModal"
            />

            <html-rendering
                    :isActiveHtmlModal='isActiveHtmlModal'
                    :htmltext="htmlContent"
                    @closeHtmlModal="closeHtmlModal"
            />

            <Notam-JsonModal
                    :isActiveNotamJsonModal = 'isActiveNotamJsonModal'
                    :WRJsonData = "WRjson_data"
                    @closeNotamJsonModal = "closeNotamJsonModal"
            />

            <Weather-JsonModal
                    :isActiveWeatherJsonModal = 'isActiveWeatherJsonModal'
                    :WRJsonData = "WRjson_data"
                    @closeWeatherJsonModal = "closeWeatherJsonModal"
            />

            <Html-Rendering
                    :isActiveHtmlModal='isActiveHtmlModal'
                    :WRJsonData="WRjson_data"
                    @closeHtmlModal="closeHtmlModal"
            />

        </div>
        <div v-else>
            <loading-button/>
        </div>

    </div>


</template>

<script>

    import {mapState, mapActions} from "vuex";
    import ShowAttachmentModal from "../../components/ui/ShowAttachmentModal";
    import ObjectRendering from "../../components/ui/ObjectRendering";
    import HtmlRendering from "../../components/ui/HtmlRendering";
    import JetplanWaitingRequestsGridModal from "../../components/ui/JetplanWaitingRequestsGridModal"
    import NotamJsonModal from "../../components/ui/NotamJsonModal";
    import WeatherJsonModal from "../../components/ui/WeatherJsonModal";
    import * as moment from 'moment';
    import HistoryService from "../../services/history.service";
    import EditFlightService from "../../services/editFlight.service";
    import LoadingButton from "../../components/ui/LoadingButton";

    export default {
        name: "FlightFolderHistory",
        data() {
            return {
                isLoading:false,
                FKeyForZip : this.$route.params.id,
                FkeyForNetline : this.$route.params.kfnl,
                SearchDate : this.$route.params.SearchDate,
                leG_NO : this.$route.params.legno,
                flight : this.$route.params.flight,
                isJeppesenDropdownActive : false,
                isJetPlanDropdownActive : false,
                tableCode: 'OFPTXT',

                htmlContent: {
                        RaimPredictionHTMLText :"<p>RaimPrediction data not found.</p>"
                },

                WaitingList: "",
                isActiveAttachmentModal: false,
                isActiveObjectModal: false,
                isActiveHtmlModal: false,
                isActiveNotamWebModal:false,
                isActiveWeatherJsonModal:false,
                isActiveJetplanWaitingRequestsGridModal : false,
                isActiveNotamJsonModal:false,
                attachmentActiveUrl: null,
                attachmentActiveFKey: null,
                OfpFlight :null,
                NotamWeb : null,
                SelectedWLVT:null,
                SelectedJLVT:null,
                lastsummary:null,
                forceManuallyControl:null,
                SelectedJSummaryId:null,
                SelectedJeppesenSummary:
                {
                    finaL_TRANS_STAT : "",
                },
                SelectedJetPlanSummary:
                {
                    weatherWebStat :0,
                },
                JLVTDropdownlist:null,
                WLVTDropdownlist:new Map(),
                WLVTDropdownlistFilteredIsSuccededs:new Map(),
                EFFdatajson:null,
                JPRdatajson:null,
                SelectedJsonDataForModal:[],
                showHideDivId: {
                    mainZipDetails: false,
                    ofpFlightDetails: false,
                    ofpTextDetails: false,
                    ofpFlightReleasePdf: false,
                    meteoDbDetails: false,
                    meteoPdfDetails: false,
                    notamDbDetails: false,
                    notamPdfDetails: false,
                    fuelHeaderDetails: false,
                    waypointDetails: false,
                    weightHeaderDetails: false,
                    weatherDetails: false,
                    notamWebDetails: false,
                    weatherWebDetails: false,
                    raimPrediction: false
                },
                selectedFlight: {
                    fKey1: "",
                    leG_NO: 0,
                    std: "",
                    sta: "",
                    atd: "",
                    ata: "",
                    carrier: "",
                    fno: "",
                    suffix: "",
                    sdep: "",
                    sarr: "",
                    adep: "",
                    aarr: "",
                    acreg: "",
                    leG_TYPE: "",
                    leG_STATE: "",
                    aC_OWNER: "",
                    cP1: "",
                    cP2: "",
                    cP3: "",
                    manuelUpdate: "",
                    whoDidManual: "",
                },

                /* ShowAllWebStats // SuccesfullWebStats   Tab Pane  */
                showSuccesfulWebStats : false,
                showAllWebStats : false,

                NetlineChangeHistoryList:[],

                // <!-- 1 DELETE siyah 2 CREATE yeşil 3 UPDATE sarı -->
                FactionStatColorList:["black","black","#27FF58","#F9F00B"],

                FactionStatEnumType:["","DELETE","CREATE","UPDATE"],
                changestatcolor : "#F9B600",


                OpenDetailsOfNetlineFlight : false,

                netlineModal: false,
                netlineChangeHistoryOriginModal: false,

                netlineChangeHistoryOrigin: []
            }
        },

        computed:
        {
            ...mapState("history", ["NetlinesyncHist","NetlineChangeHistoryData","weatherModalUrl","releaseModalUrl","flightFolderHistoryWithZip", "SummaryVersionsData","EFFjson_data","WRjson_data","AttachmentsJson"]),
        },

        components:
        {
            ShowAttachmentModal,
            ObjectRendering,
            HtmlRendering,
            JetplanWaitingRequestsGridModal,
            NotamJsonModal,
            WeatherJsonModal,
            LoadingButton

        },

        methods: {

            ...mapActions("history", ["getNetlineChangeHistoryOrigin","getNetlineSyncHistData","getNetlineChangeHistoryByLegNo",
                                      "getFlightFolderHistoryWithZip", "getJsonData",
                "getJsonDataOfpFlight", "getSummaryVersionsData","getSummaryVersionsDataByLegno", "GetWRjson", "GetEffJson", "ClearStates"]),

            ConvertJsontoList(value)
            {
                let val = JSON.parse(value);

                console.log(val);
                //console.log(val);
                return val;
            },

            ConvertJsonStringfyToList(value)
            {
                let val = JSON.stringify(value)
                console.log(val);
                return val;
            },

            CloseDetailsOfNetlineFlightHistory(value,index)
            {
                console.log(value+index)

            },

            OpenCloseDetailsOfAttachmentHistoric(value,index)
            {
                // let res = !value;
                this.NetlineChangeHistoryList[index].AttachmentHistoricTabShow= !value;

                this.NetlineChangeHistoryList[index].JsonAttachmentHistory = this.ConvertJsontoList(this.NetlineChangeHistoryList[index].AttachmentHistory)

            },

            OpenCloseDetailsOfSyncOCCHistoric(value,index)
            {
                // let res = !value;
                this.NetlineChangeHistoryList[index].SyncOCCHisctoricTabShow= !value;

                this.NetlineChangeHistoryList[index].JsonSyncOccHistory = this.ConvertJsontoList(this.NetlineChangeHistoryList[index].SyncOccHistory)

            },

            OpenCloseDetailsJeppesenOfHistoric(value,index)
            {
                // let res = !value;
                this.NetlineChangeHistoryList[index].JeppesenHistoricTabShow= !value;

                this.NetlineChangeHistoryList[index].JsonJeppesenJetplan = this.ConvertJsonStringfyToList(this.NetlineChangeHistoryList[index].JeppesenJetplan)
                console.log(this.NetlineChangeHistoryList[index].JsonJeppesenJetplan)
            },

            CustomDate(value)
            {
                return  moment(value).format('YYYY-MM-DD HH:mm:ss');
            },

            closeAttachmentModal() {
                this.isActiveAttachmentModal = false;
            },

            closeObjectModal() {
                this.isActiveObjectModal = false;
            },

            closeHtmlModal() {
                this.isActiveHtmlModal = false;
            },

            closeNotamWebModal()
            {
                this.isActiveNotamWebModal = false;
            },

            closeNotamJsonModal()
            {
                this.isActiveNotamJsonModal = false;
            },

            closeWeatherJsonModal()
            {
                this.isActiveWeatherJsonModal = false;
            },

            closeJetplanWaitingRequestsGridModal()
            {
              this.isActiveJetplanWaitingRequestsGridModal = false;
            },

            async JustGetNetlinesyncSummary()
            {

                try
                {
                    await this.getNetlineSyncHistData();
                }
                catch(e)
                {
                    this.$notify({title: "Error", text:"JustGetNetlinesyncSummary function "+ e.message, type: "error"});
                }
            },

            async ShowNetlineChangeHistOriginByDay()
            {
                this.netlineChangeHistoryOriginModal = true;
                try
                {
                var std = this.calculateSTDFromNetline();
                // module service isteği olacak... // buna nasıl parametre göndereceğiz, async await olayı nasıl çalışıyor ???
                this.netlineChangeHistoryOrigin = await this.getNetlineChangeHistoryOrigin(std);
                }
                catch(e)
                {
                    //this.$notify({title: "Error", text:"getNetlineChangeHistoryOrigin function "+ e.message, type: "error"});
                }
                // this.netlineChangeHistoryOrigin = this.$store.dispatch("history/getNetlineChangeHistoryOrigin")
            },


            ShowNetlineLastSyncHist()
            {
                try
                {
                    this.netlineModal = true;
                    this.getNetlineSyncHistData();
                }
                catch(e)
                {
                    //this.$notify({title: "Error", text:"Error on Show Netline Last Sync Hist function "+ e.message, type: "error"});
                }

                // fetch data from api
                // make modal true
            },

            async getFlightbyid(KFNL,LEGNO,STD) {

                try
                {
                    var flightList = await EditFlightService.getSelectedFlightByLegNo(STD,LEGNO);
                    console.log(flightList+ " get flight by KFZ STD");
                    console.log(flightList);
                    this.selectedFlight = flightList;
                    this.flight = flightList;
                    this.selectedFlight.fno = this.selectedFlight.fno + this.selectedFlight.suffix;
                    return flightList;

                } catch (e) {
                    //this.$notify({title: "info", text:"Error on getSelectedFlightByLegNo function "+ e.message, type: "warning"});
                }

            },

            async LoadJLVTlist()
            {
                try {

                        let data = new Map();

                        for (let obj of this.SummaryVersionsData)
                        {
                            if (obj.jlvt == this.SelectedJLVT)
                            {
                                data.set( obj.wlvt, obj );
                            }
                        }

                        this.WLVTDropdownlist = data;
                        this.SelectedJeppesenSummary = this.SummaryVersionsData.find(x=>x.jlvt == this.SelectedJLVT);
                        await this.GetEffJson({KFZ:this.SelectedJeppesenSummary.fKeyForZip, STD:this.flight.std, JLVT:this.SelectedJLVT, ArchiveStat:this.flight.flightArchiveStat});

                        // if(this.SelectedWLVT != 0)
                        // {this.loadWLVT();}
                        //this.loadWLVT();
                        this.LoadWlvtSelectionChanged();
                }
                catch(e)
                {
                    //this.$notify({title:"warning", text: "Error occurued while getting jeppesen data. e:"+e.message,type:"warning"});
                }
            },

            async loadWLVT()
            {
                try
                {
                    if(this.SelectedWLVT != 0)
                    {
                        this.SelectedJetPlanSummary = this.SummaryVersionsData.find(x=>x.wlvt == this.SelectedWLVT);

                        await this.GetWRjson({KFZ:this.SelectedJetPlanSummary.fKeyForZip, STD:this.flight.std, WLVT:this.SelectedWLVT, flightArchiveStat:this.flight.flightArchiveStat});
                    }
                }
                catch(e)
                {
                    //this.$notify({title:"Error", text: "Error on loadWLVT function "+e.message ,type:"error"});
                }
            },

            async LoadWlvtSelectionChanged()
            {
                let sm = this.WLVTDropdownlist.entries().next().value

                this.SelectedWLVT = sm[0]
                this.SelectedJetPlanSummary = this.SummaryVersionsData.find(x=>x.wlvt == this.SelectedWLVT);
                //this.SelectedWLVT = this.this.WLVTDropdownlist[0]

                await this.GetWRjson({KFZ:this.SelectedJetPlanSummary.fKeyForZip, STD:this.flight.std, WLVT:this.SelectedWLVT, flightArchiveStat:this.flight.flightArchiveStat});
            },

            GelAllWebStats()
            {
                this.showAllWebStats = true;
                this.showSuccesfulWebStats = false;

                // websummaryall tablosundan jeppesena göre bilgi çekilecektir.
            },

            GetSuccesfullWebStats()
            {
                this.showAllWebStats = false;
                this.showSuccesfulWebStats = true;
                this.WLVTDropdownlistFilteredIsSuccededs = new Map([...this.WLVTDropdownlist].filter(([k, v]) => v.finaL_TRANS_STAT===1 && k==k));
                // websummary tablosundan jeppesena göre bilgi çekilecektir.
            },

            async ForceUpdate(isForceManually)
            {
                try
                {
                    var result = await HistoryService.ForceUpdate(this.SelectedJSummaryId, isForceManually);

                    if(result.stat == 1)
                    {
                        //this.$notify({title: "Success", text: "Stat is "+ result.stat +" "+ result.message, type: "success"});
                    }
                    else if(result.stat == 2)
                    {
                        //this.$notify({title: "Warning", text: "Stat is "+ result.stat +" "+ result.message, type: "warn"});
                    }

                    this.forceManuallyControl = result.isForcedManually;

                    var ForcedManuallyStat = await HistoryService.GetForceManuallyStat(this.SelectedJSummaryId);
                    this.forceManuallyControl = ForcedManuallyStat;

                    this.PageReloadAllData();
                }
                catch(e)
                {
                    //this.$notify({title: "Error", text:"Error on ForceUpdate function " + e.message, type: "error"});
                }
            },

            async GetHtmlDataR()
            {
                this.htmlContent = this.WRjson_data;
                this.isActiveHtmlModal = true;
            },

            async ShowJetplanWaitingRequestsGridModal()
            {
                this.isActiveJetplanWaitingRequestsGridModal = true;
                this.WaitingList = []

                try
                {
                    this.WaitingList = await HistoryService.GetList_JetplanWaitingRequests();
                }
                catch(e) {
                    //this.$notify({title: "Error", text:"Error on function. GetList_JetplanWaitingRequests e:" + e.message, type: "error"});
                }


                console.log(this.WaitingList);
            },

            JsonDataBuilderForModal(value)
            {
                this.SelectedJsonDataForModal = [];
                this.SelectedJsonDataForModal.push(value);
                this.isActiveObjectModal = true;
            },

            ListJsonDataBuilderForModal(value)
            {
                alert("ListJsonDataBuilderForModal")
                this.SelectedJsonDataForModal = [];
                this.SelectedJsonDataForModal = value;
                this.isActiveObjectModal = true;
            },

            showAttachmentReleaseModal()
            {
                this.isActiveAttachmentModal = true;
                //alert("showAttachmentReleaseModal"+this.attachmentActiveUrl)
                this.attachmentActiveUrl = this.releaseModalUrl +  this.SelectedJeppesenSummary.fKeyForZip +'/'+ this.flight.std +'/'+ this.SelectedJLVT+'/'+this.flight.flightArchiveStat;
            },

            showWeatherChartModal()
            {
                this.isActiveAttachmentModal = true;
                //alert("showWeatherChartModal"+this.attachmentActiveUrl)
                this.attachmentActiveUrl = this.weatherModalUrl + this.SelectedJeppesenSummary.fKeyForZip +'/'+ this.flight.std +'/'+this.SelectedWLVT+'/'+this.flight.flightArchiveStat;
            },

            showNotamWebModal()
            {
                this.isActiveNotamJsonModal = true;
            },

            showWeatherWebModal()
            {
                this.isActiveWeatherJsonModal = true;
            },

            TryGetIpadPreview()
            {
                this.$router.push({name: 'IpadMain', params: {id: this.FKeyForZip,kfnl:this.FkeyForNetline,legno:this.leG_NO,flight: this.flight}});
            },

            openOrCloseAllDetails(value)
            {
                var items = this.showHideDivId;
                var x;
                for (x in items) {
                    items[x] = value;
                }
            },

            openObjectModal()
            {
                this.isActiveObjectModal = true;
            },

            calculateSTDFromNetline()
            {
                var keylist = this.FkeyForNetline.split("_");
                var date = keylist[2];

                return date = date.substring(0,4)+"-"+date.substring(4,6)+"-"+date.substring(6,8)+"T00:00:00";

            },

            async PageReloadAllData()// Deprecated Function..
            {

                this.isLoading = true;
                this.showAllWebStats = true;
                this.ClearStates();

                // bu kısımda keyfornetline ile std bilgisinin alınarak sp de kullanılması gerekmektedir.
                var keylist = this.FkeyForNetline.split("_");
                var date = keylist[2];

                date = date.substring(0,4)+"-"+date.substring(4,6)+"-"+date.substring(6,8)+"T00:00:00";

                try
                {
                    this.getFlightbyid(this.FkeyForNetline,this.leG_NO,date);

                }
                catch(e)
                {
                    //this.$notify({title: "Error", text:"Error on get Flight by id process "+ e.message, type: "error"});

                }

                try
                {
                   await this.getNetlineChangeHistoryByLegNo(this.leG_NO);

                }
                catch(e)
                {
                    //this.$notify({title: "Error", text:"Error on get Netline Change History By LegNo process "+ e.message, type: "error"});

                }

                await this.CalculateChangesOfNetlineChanges();

                try {

                    await this.getSummaryVersionsDataByLegno(this.leG_NO);

                }
                catch(e) {

                    //this.$notify({title: "Error", text:"Error on get Summary Versions Data By Legno process "+ e.message, type: "error"});

                }

                if(!this.flightFolderHistoryWithZip)
                {
                    this.isLoading = false;
                    return;
                }

                let data = new Map();

                for (let obj of this.SummaryVersionsData)
                {
                    data.set(obj.jlvt, obj);
                }

                this.JLVTDropdownlist = data;
                this.lastsummary =this.SummaryVersionsData[0];

                this.SelectedJLVT = this.lastsummary.jlvt;
                this.SelectedWLVT = this.lastsummary.wlvt;

                this.forceManuallyControl = this.lastsummary.isForcedManually;
                this.SelectedJSummaryId = this.lastsummary.idjSummary;

                this.LoadJLVTlist();
                // this.loadWLVT();  // zaten jlvt list içinde yüklenme yapılmaktadır.

                this.htmlContent = this.WRjson_data;
                this.SearchDate = this.selectedFlight.std.toString().substring(0,10);
                var ForcedManuallyStat = await HistoryService.GetForceManuallyStat(this.SelectedJSummaryId);
                this.forceManuallyControl = ForcedManuallyStat;
                this.isLoading = false;
            },

            async CalculateChangesOfNetlineChanges()
            {

                    // this.NetlineChangeHistoryList = this.NetlineChangeHistoryData; // stateden geleni
                    var oldindex = 0;

                    for (let i = 0; i < this.NetlineChangeHistoryData.length; i++)
                    {

                        oldindex = (i>0)? i-1:0;

                        this.NetlineChangeHistoryList.push({
                            aC_OWNER: this.NetlineChangeHistoryData[i].aC_OWNER,
                            aC_OWNER_Change: (this.NetlineChangeHistoryData[i].aC_OWNER == this.NetlineChangeHistoryData[oldindex].aC_OWNER) ? false : true,

                            aarR_ICAO: this.NetlineChangeHistoryData[i].aarR_ICAO,
                            aarR_ICAO_Change: (this.NetlineChangeHistoryData[i].aarR_ICAO == this.NetlineChangeHistoryData[oldindex].aarR_ICAO) ? false : true,

                            aarr: this.NetlineChangeHistoryData[i].aarr,
                            aarr_Change: (this.NetlineChangeHistoryData[i].aarr == this.NetlineChangeHistoryData[oldindex].aarr) ? false : true,

                            acreg: this.NetlineChangeHistoryData[i].acreg,
                            acreg_Change: (this.NetlineChangeHistoryData[i].acreg == this.NetlineChangeHistoryData[oldindex].acreg) ? false : true,

                            adeP_ICAO: this.NetlineChangeHistoryData[i].adeP_ICAO,
                            adeP_ICAO_Change: (this.NetlineChangeHistoryData[i].adeP_ICAO == this.NetlineChangeHistoryData[oldindex].adeP_ICAO) ? false : true,

                            adep: this.NetlineChangeHistoryData[i].adep,
                            adep_Change: (this.NetlineChangeHistoryData[i].adep == this.NetlineChangeHistoryData[oldindex].adep) ? false : true,

                            ata: this.NetlineChangeHistoryData[i].ata,
                            ata_Change: (this.NetlineChangeHistoryData[i].ata == this.NetlineChangeHistoryData[oldindex].ata) ? false : true,

                            atd: this.NetlineChangeHistoryData[i].atd,
                            atd_Change: (this.NetlineChangeHistoryData[i].atd == this.NetlineChangeHistoryData[oldindex].atd) ? false : true,

                            cP1: this.NetlineChangeHistoryData[i].cP1,
                            cP1_Change: (this.NetlineChangeHistoryData[i].cP1 == this.NetlineChangeHistoryData[oldindex].cP1) ? false : true,

                            cP2: this.NetlineChangeHistoryData[i].cP2,
                            cP2_Change: (this.NetlineChangeHistoryData[i].cP2 == this.NetlineChangeHistoryData[oldindex].cP2) ? false : true,

                            cP3: this.NetlineChangeHistoryData[i].cP3,
                            cP3_Change: (this.NetlineChangeHistoryData[i].cP3 == this.NetlineChangeHistoryData[oldindex].cP3) ? false : true,

                            cabinList: this.NetlineChangeHistoryData[i].cabinList,
                            cabinList_Change: (this.NetlineChangeHistoryData[i].cabinList == this.NetlineChangeHistoryData[oldindex].cabinList) ? false : true,

                            callsign: this.NetlineChangeHistoryData[i].callsign,
                            callsign_Change: (this.NetlineChangeHistoryData[i].callsign == this.NetlineChangeHistoryData[oldindex].callsign) ? false : true,

                            carrier: this.NetlineChangeHistoryData[i].carrier,
                            carrier_Change: (this.NetlineChangeHistoryData[i].carrier == this.NetlineChangeHistoryData[oldindex].carrier) ? false : true,

                            cntJ: this.NetlineChangeHistoryData[i].cntJ,
                            cntJ_Change: (this.NetlineChangeHistoryData[i].cntJ == this.NetlineChangeHistoryData[oldindex].cntJ) ? false : true,

                            jlvT_RANGE:this.NetlineChangeHistoryData[i].jlvT_RANGE,
                            jlvT_RANGE_Change:(this.NetlineChangeHistoryData[i].jlvT_RANGE == this.NetlineChangeHistoryData[oldindex].jlvT_RANGE) ? false : true,

                            createdt: this.NetlineChangeHistoryData[i].createdt,
                            createdt_Change: (this.NetlineChangeHistoryData[i].createdt == this.NetlineChangeHistoryData[oldindex].createdt) ? false : true,

                            diS_DT: this.NetlineChangeHistoryData[i].diS_DT,
                            diS_DT_Change: (this.NetlineChangeHistoryData[i].diS_DT == this.NetlineChangeHistoryData[oldindex].diS_DT) ? false : true,

                            diS_DTYPE: this.NetlineChangeHistoryData[i].diS_DTYPE,
                            diS_DTYPE_Change: (this.NetlineChangeHistoryData[i].diS_DTYPE == this.NetlineChangeHistoryData[oldindex].diS_DTYPE) ? false : true,

                            diV_AARR_ICAO: this.NetlineChangeHistoryData[i].diV_AARR_ICAO,
                            diV_AARR_ICAO_Change: (this.NetlineChangeHistoryData[i].diV_AARR_ICAO == this.NetlineChangeHistoryData[oldindex].diV_AARR_ICAO) ? false : true,

                            diV_ARR: this.NetlineChangeHistoryData[i].diV_ARR,
                            diV_ARR_Change: (this.NetlineChangeHistoryData[i].diV_ARR == this.NetlineChangeHistoryData[oldindex].diV_ARR) ? false : true,

                            fKeyForNetline: this.NetlineChangeHistoryData[i].fKeyForNetline,
                            fKeyForNetline_Change: (this.NetlineChangeHistoryData[i].fKeyForNetline == this.NetlineChangeHistoryData[oldindex].fKeyForNetline) ? false : true,

                            fKeyForZip: this.NetlineChangeHistoryData[i].fKeyForZip,
                            fKeyForZip_Change: (this.NetlineChangeHistoryData[i].fKeyForZip == this.NetlineChangeHistoryData[oldindex].fKeyForZip) ? false : true,

                            faction: this.NetlineChangeHistoryData[i].faction,
                            faction_Change: (this.NetlineChangeHistoryData[i].faction == this.NetlineChangeHistoryData[oldindex].faction) ? false : true,

                            fnO7_WITH_SFX: this.NetlineChangeHistoryData[i].fnO7_WITH_SFX,
                            fnO7_WITH_SFX_Change: (this.NetlineChangeHistoryData[i].fnO7_WITH_SFX == this.NetlineChangeHistoryData[oldindex].fnO7_WITH_SFX) ? false : true,

                            fno: this.NetlineChangeHistoryData[i].fno,
                            fno_Change: (this.NetlineChangeHistoryData[i].fno == this.NetlineChangeHistoryData[oldindex].fno) ? false : true,

                            hiS_DT: this.NetlineChangeHistoryData[i].hiS_DT,
                            hiS_DT_Change: (this.NetlineChangeHistoryData[i].hiS_DT == this.NetlineChangeHistoryData[oldindex].hiS_DT) ? false : true,

                            id: this.NetlineChangeHistoryData[i].id,
                            id_Change: (this.NetlineChangeHistoryData[i].id == this.NetlineChangeHistoryData[oldindex].id) ? false : true,

                            lastChangeInfo: this.NetlineChangeHistoryData[i].lastChangeInfo,
                            lastChangeInfo_Change: (this.NetlineChangeHistoryData[i].lastChangeInfo == this.NetlineChangeHistoryData[oldindex].lastChangeInfo) ? false : true,

                            lastSync: this.NetlineChangeHistoryData[i].lastSync,
                            lastSync_Change: (this.NetlineChangeHistoryData[i].lastSync == this.NetlineChangeHistoryData[oldindex].lastSync) ? false : true,

                            leG_NO: this.NetlineChangeHistoryData[i].leG_NO,
                            leG_NO_Change: (this.NetlineChangeHistoryData[i].leG_NO == this.NetlineChangeHistoryData[oldindex].leG_NO) ? false : true,

                            leG_STATE: this.NetlineChangeHistoryData[i].leG_STATE,
                            leG_STATE_Change: (this.NetlineChangeHistoryData[i].leG_STATE == this.NetlineChangeHistoryData[oldindex].leG_STATE) ? false : true,

                            leG_TYPE: this.NetlineChangeHistoryData[i].leG_TYPE,
                            leG_TYPE_Change: (this.NetlineChangeHistoryData[i].leG_TYPE == this.NetlineChangeHistoryData[oldindex].leG_TYPE) ? false : true,

                            manuelUpdate: this.NetlineChangeHistoryData[i].manuelUpdate,
                            manuelUpdate_Change: (this.NetlineChangeHistoryData[i].manuelUpdate == this.NetlineChangeHistoryData[oldindex].manuelUpdate) ? false : true,

                            modifydate: this.NetlineChangeHistoryData[i].modifydate,
                            modifydate_Change: (this.NetlineChangeHistoryData[i].modifydate == this.NetlineChangeHistoryData[oldindex].modifydate) ? false : true,

                            nlvt: this.NetlineChangeHistoryData[i].nlvt,
                            nlvt_Change: (this.NetlineChangeHistoryData[i].nlvt == this.NetlineChangeHistoryData[oldindex].nlvt) ? false : true,

                            otheR_PARAMS_TEXT: this.NetlineChangeHistoryData[i].otheR_PARAMS_TEXT,
                            otheR_PARAMS_TEXT_Change: (this.NetlineChangeHistoryData[i].otheR_PARAMS_TEXT == this.NetlineChangeHistoryData[oldindex].otheR_PARAMS_TEXT) ? false : true,

                            sarr: this.NetlineChangeHistoryData[i].sarr,
                            sarr_Change: (this.NetlineChangeHistoryData[i].sarr == this.NetlineChangeHistoryData[oldindex].sarr) ? false : true,

                            sdep: this.NetlineChangeHistoryData[i].sdep,
                            sdep_Change: (this.NetlineChangeHistoryData[i].sdep == this.NetlineChangeHistoryData[oldindex].sdep) ? false : true,

                            sdeP_ICAO: this.NetlineChangeHistoryData[i].sdeP_ICAO,
                            sdeP_ICAO_Change: (this.NetlineChangeHistoryData[i].sdeP_ICAO == this.NetlineChangeHistoryData[oldindex].sdeP_ICAO) ? false : true,

                            sarR_ICAO: this.NetlineChangeHistoryData[i].sarR_ICAO,
                            sarR_ICAO_Change: (this.NetlineChangeHistoryData[i].sarR_ICAO == this.NetlineChangeHistoryData[oldindex].sarR_ICAO) ? false : true,

                            sta: this.NetlineChangeHistoryData[i].sta,
                            sta_Change: (this.NetlineChangeHistoryData[i].sta == this.NetlineChangeHistoryData[oldindex].sta) ? false : true,

                            std: this.NetlineChangeHistoryData[i].std,
                            std_Change: (this.NetlineChangeHistoryData[i].std == this.NetlineChangeHistoryData[oldindex].std) ? false : true,

                            suffix: this.NetlineChangeHistoryData[i].suffix,
                            suffix_Change: (this.NetlineChangeHistoryData[i].suffix == this.NetlineChangeHistoryData[oldindex].suffix) ? false : true,

                            tarih: this.NetlineChangeHistoryData[i].tarih,
                            tarih_Change: (this.NetlineChangeHistoryData[i].tarih == this.NetlineChangeHistoryData[oldindex].tarih) ? false : true,

                            updatekey: this.NetlineChangeHistoryData[i].updatekey,
                            updatekey_Change: (this.NetlineChangeHistoryData[i].updatekey == this.NetlineChangeHistoryData[oldindex].updatekey) ? false : true,

                            whenDidManual: this.NetlineChangeHistoryData[i].whenDidManual,
                            whenDidManual_Change: (this.NetlineChangeHistoryData[i].whenDidManual == this.NetlineChangeHistoryData[oldindex].whenDidManual) ? false : true,

                            whoDidManual: this.NetlineChangeHistoryData[i].whoDidManual,
                            whoDidManual_Change: (this.NetlineChangeHistoryData[i].whoDidManual == this.NetlineChangeHistoryData[oldindex].whoDidManual) ? false : true,

                            // sample Json
                            OpenCloseDetailsStat: false,
                            AttachmentHistoricTabShow: false,
                            SyncOCCHisctoricTabShow:false,
                            JeppesenHistoricTabShow:false,

                            AttachmentHistory:  (i%2==0) ? [
                                {
                                    "ALVT": 20776,
                                    "LastKeyForNetline": "TCTJS_CXI192_20220307_EDDB_HEGN002",
                                    "FKeyForZip": "TCTJS_CXI192_20220307_EDDB_HEGN",
                                    "ToleratedJLVT": 0,
                                    "ToleratedWLVT": 0,
                                    "AttachmentTypeId": 0,
                                    "RealName": "CXI_APPROVALS_UPDATED.PDF",
                                    "FileType": "pdf",
                                    "Description": "",
                                    "CreatedAt": "08:58.4",
                                    "ModifiedAt": "08:58.4",
                                    "UploadedBy": "Deniz",
                                    "FileSize": "Koçman",
                                    "IsDeleted": 297
                                },
                                {
                                    "ALVT": 20775,
                                    "LastKeyForNetline": "TCTJS_CXI192_20220307_EDDB_HEGN002",
                                    "FKeyForZip": "TCTJS_CXI192_20220307_EDDB_HEGN",
                                    "ToleratedJLVT": 0,
                                    "ToleratedWLVT": 0,
                                    "AttachmentTypeId": 0,
                                    "RealName": "AIP_SUPS_AMDTS.PDF",
                                    "FileType": "pdf",
                                    "Description": "",
                                    "CreatedAt": "08:52.0",
                                    "ModifiedAt": "08:52.0",
                                    "UploadedBy": "Deniz",
                                    "FileSize": "Koçman",
                                    "IsDeleted": 758
                                },
                                {
                                    "ALVT": 20774,
                                    "LastKeyForNetline": "TCTJS_CXI192_20220307_EDDB_HEGN002",
                                    "FKeyForZip": "TCTJS_CXI192_20220307_EDDB_HEGN",
                                    "ToleratedJLVT": 0,
                                    "ToleratedWLVT": 0,
                                    "AttachmentTypeId": 0,
                                    "RealName": "CAI_CXI_2022-02-11_FOE_BRIEFING_BULLETIN.PDF",
                                    "FileType": "pdf",
                                    "Description": "",
                                    "CreatedAt": "08:45.6",
                                    "ModifiedAt": "08:45.6",
                                    "UploadedBy": "Deniz",
                                    "FileSize": "Koçman",
                                    "IsDeleted": 396
                                },
                                {
                                    "ALVT": 20773,
                                    "LastKeyForNetline": "TCTJS_CXI192_20220307_EDDB_HEGN002",
                                    "FKeyForZip": "TCTJS_CXI192_20220307_EDDB_HEGN",
                                    "ToleratedJLVT": 0,
                                    "ToleratedWLVT": 0,
                                    "AttachmentTypeId": 0,
                                    "RealName": "CAFIF.PDF",
                                    "FileType": "pdf",
                                    "Description": "",
                                    "CreatedAt": "08:37.7",
                                    "ModifiedAt": "08:37.7",
                                    "UploadedBy": "Deniz",
                                    "FileSize": "Koçman",
                                    "IsDeleted": 104
                                }
                            ] : (i%3==0)?  "" : "",
                            SyncOccHistory:     (i%2==0) ?  [{"ID":57099,"FKeyForZip":"TCCOE_CXI9022_20220308_LEPA_EDDG","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B3B","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57098,"FKeyForZip":"TCCOE_CXI9024_20220308_GCRR_EDDG","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B3A","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57097,"FKeyForZip":"TCCOE_CXI9021_20220308_EDDG_LEPA","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B39","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57096,"FKeyForZip":"TCCOE_CXI9023_20220308_EDDG_GCRR","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B38","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57095,"FKeyForZip":"TCTJS_CXI291_20220308_HEGN_EDDR","DEVICE_UUID1":"44DC676D-BC0E-430D-9449-693F63726274","TLC1":"DGT","STATTEXT1":"N1J2W2A120220307042711_20220307042711","STAT_MIN1":2,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":9206166875,"STAT_MIN2":0,"DEVICE_UUID3":0,"TLC3":"0x0000000225734B37","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57094,"FKeyForZip":"TCTJS_CXI292_20220308_EDDR_HEGN","DEVICE_UUID1":"44DC676D-BC0E-430D-9449-693F63726274","TLC1":"DGT","STATTEXT1":"N1J2W2A120220307042711_20220307042711","STAT_MIN1":2,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":9206189931,"STAT_MIN2":0,"DEVICE_UUID3":0,"TLC3":"0x0000000225734B36","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57093,"FKeyForZip":"9HTJA_CAI2283_20220308_EDDV_LTAI","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B35","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57092,"FKeyForZip":"9HTJA_CAI2284_20220308_LTAI_EDDV","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B34","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57091,"FKeyForZip":"9HCXC_CXI4027_20220308_EDDL_GCRR","DEVICE_UUID1":"32BA491E-6545-46BC-B691-01D16DF89A72","TLC1":"BAE","STATTEXT1":"N1J2W2A120220307030710_20220307030710","STAT_MIN1":2,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":9179662862,"STAT_MIN2":0,"DEVICE_UUID3":0,"TLC3":"0x0000000225734B33","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57090,"FKeyForZip":"9HCXC_CXI4028_20220308_GCRR_EDDL","DEVICE_UUID1":"32BA491E-6545-46BC-B691-01D16DF89A72","TLC1":"BAE","STATTEXT1":"N1J2W2A120220307030710_20220307030710","STAT_MIN1":2,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":9179662866,"STAT_MIN2":0,"DEVICE_UUID3":0,"TLC3":"0x0000000225734B32","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57089,"FKeyForZip":"9HTJA_CXI2226_20220308_GCRR_EDDV","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B31","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57088,"FKeyForZip":"TCTJY_CAI1920_20220308_EHAM_LTAI","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B30","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57087,"FKeyForZip":"9HTJD_CXI1024_20220308_HEGN_EDDK","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B2F","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57086,"FKeyForZip":"TCTJP_CAI5203_20220308_LTAU_LTAN","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B2E","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57085,"FKeyForZip":"9HTJA_CXI2225_20220308_EDDV_GCRR","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B2D","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57084,"FKeyForZip":"9HTJE_CXI2201_20220308_GCFV_ETNL","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B2C","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57083,"FKeyForZip":"9HTJF_CXI2121_20220308_EDDN_LEPA","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B2B","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57082,"FKeyForZip":"TCTJO_CAI456_20220308_LLBG_LTAI","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B2A","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57081,"FKeyForZip":"9HCXA_CXI2123_20220308_EDDN_GCLP","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B29","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57080,"FKeyForZip":"TCTJO_CAI2535_20220308_LTAI_EDDH","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B28","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57079,"FKeyForZip":"9HTJE_CXI2227_20220308_EDDV_GCFV","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B27","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57078,"FKeyForZip":"9HTJE_CXI2202_20220308_ETNL_GCFV","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B26","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57077,"FKeyForZip":"9HTJD_CXI1023_20220308_EDDK_HEGN","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B25","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57076,"FKeyForZip":"TCCOH_CAI3523_20220308_LTBJ_EDDL","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B24","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""},{"ID":57075,"FKeyForZip":"9HTJB_CXI4024_20220308_LPMA_EDDL","DEVICE_UUID1":0,"TLC1":0,"STATTEXT1":0,"STAT_MIN1":0,"DEVICE_UUID2":0,"TLC2":0,"STATTEXT2":"0x0000000225734B23","STAT_MIN2":"","DEVICE_UUID3":"","TLC3":"","STATTEXT3":"","STAT_MIN3":"","MaxDataverLVC1":"","MaxDataverLVC2":"","MaxDataverLVC3":"","Dataver":""}] : "",
                            JeppesenJetplan:    (i%2==0) ?  [{"Id":73234,"IDJSummary":21716,"FINAL_TRANS_STAT":1,"FKeyForZip":"TCTJU_CAI5408_20220225_EDLV_LTAI","StartTime":"2022-02-25 12:38:33.397","EndTime":"2022-02-25 14:15:26.740","JLVT":3,"WLVT":5,"IsForcedManually":0,"LastProcess":14,"UnzipStat":1,"UnzipLastError":"2022-02-25 12:38:33.403","UnzipLastActionDT":1,"OfpFlightStat":"2022-02-25 12:38:33.443","OfpFlightLastError":3,"OfpLastActionDT":1,"OfpFlightVersionCount":"2022-02-25 12:38:33.473","OfpTextStat":3,"OfpTextLastError":1,"OfpTextLastActionDT":"2022-02-25 12:38:33.473","OfpTextVersionCount":3,"OfpFlightReleasePdfStat":1,"OfpFlightReleasePdfLastError":"2022-02-25 12:38:33.473","OfpFlightReleasePdfLastActionDT":3,"OfpFlightReleasePdfVersionCount":1,"MeteoPdfStat":"2022-02-25 12:38:33.490","MeteoPdfLastError":3,"MeteoPdfLastActionDT":1,"MeteoPdfVersionCount":"2022-02-25 12:38:33.570","NotamPdfStat":3,"NotamPdfLastError":1,"NotamPdfLastActionDT":"2022-02-25 12:38:33.570","NotamPdfVersionCount":3,"FuelHeaderStat":1,"FuelHeaderLastError":"2022-02-25 12:38:33.570","FuelHeaderLastActionDT":3,"FuelHeaderVersionCount":1,"WaypointStat":"2022-02-25 14:14:16.173","WaypointLastError":5,"WaypointLastActionDT":1,"WaypointVersionCount":"2022-02-25 14:14:18.933","WeightHeaderStat":5,"WeightHeaderLastError":1,"WeightHeaderLastActionDT":"2022-02-25 14:14:33.613","WeightHeaderVersionCount":5,"WeatherChartStat":1,"WeatherChartLastError":"2022-02-25 14:15:14.453","WeatherChartLastActionDT":5,"WeatherChartVersionCount":9991,"WeatherWebStat":"0x00000001E459F503","WeatherWebLastError":"","WeatherWebLastActionDT":"","WeatherWebVersionCount":"","NotamWebStat":"","NotamWebLastError":"","NotamWebLastActionDT":"","NotamWebVersionCount":"","RaimPredictionStat":"","RaimPredictionLastError":"","RaimPredictionLastActionDT":"","RaimPredictionVersionCount":"","LAST_PLAN_ID_SUCCEED":"","DataVer":""},{"Id":73234,"IDJSummary":21716,"FINAL_TRANS_STAT":1,"FKeyForZip":"TCTJU_CAI5408_20220225_EDLV_LTAI","StartTime":"2022-02-25 12:38:33.397","EndTime":"2022-02-25 13:48:37.997","JLVT":3,"WLVT":4,"IsForcedManually":0,"LastProcess":14,"UnzipStat":1,"UnzipLastError":"2022-02-25 12:38:33.403","UnzipLastActionDT":1,"OfpFlightStat":"2022-02-25 12:38:33.443","OfpFlightLastError":3,"OfpLastActionDT":1,"OfpFlightVersionCount":"2022-02-25 12:38:33.473","OfpTextStat":3,"OfpTextLastError":1,"OfpTextLastActionDT":"2022-02-25 12:38:33.473","OfpTextVersionCount":3,"OfpFlightReleasePdfStat":1,"OfpFlightReleasePdfLastError":"2022-02-25 12:38:33.473","OfpFlightReleasePdfLastActionDT":3,"OfpFlightReleasePdfVersionCount":1,"MeteoPdfStat":"2022-02-25 12:38:33.490","MeteoPdfLastError":3,"MeteoPdfLastActionDT":1,"MeteoPdfVersionCount":"2022-02-25 12:38:33.570","NotamPdfStat":3,"NotamPdfLastError":1,"NotamPdfLastActionDT":"2022-02-25 12:38:33.570","NotamPdfVersionCount":3,"FuelHeaderStat":1,"FuelHeaderLastError":"2022-02-25 12:38:33.570","FuelHeaderLastActionDT":3,"FuelHeaderVersionCount":1,"WaypointStat":"2022-02-25 13:47:30.417","WaypointLastError":4,"WaypointLastActionDT":1,"WaypointVersionCount":"2022-02-25 13:47:32.943","WeightHeaderStat":4,"WeightHeaderLastError":1,"WeightHeaderLastActionDT":"2022-02-25 13:47:47.780","WeightHeaderVersionCount":4,"WeatherChartStat":1,"WeatherChartLastError":"2022-02-25 13:48:26.500","WeatherChartLastActionDT":4,"WeatherChartVersionCount":9991,"WeatherWebStat":"0x00000001E459F503","WeatherWebLastError":"","WeatherWebLastActionDT":"","WeatherWebVersionCount":"","NotamWebStat":"","NotamWebLastError":"","NotamWebLastActionDT":"","NotamWebVersionCount":"","RaimPredictionStat":"","RaimPredictionLastError":"","RaimPredictionLastActionDT":"","RaimPredictionVersionCount":"","LAST_PLAN_ID_SUCCEED":"","DataVer":""},{"Id":73234,"IDJSummary":21716,"FINAL_TRANS_STAT":1,"FKeyForZip":"TCTJU_CAI5408_20220225_EDLV_LTAI","StartTime":"2022-02-25 12:38:33.397","EndTime":"2022-02-25 13:02:43.153","JLVT":3,"WLVT":3,"IsForcedManually":0,"LastProcess":14,"UnzipStat":1,"UnzipLastError":"2022-02-25 12:38:33.403","UnzipLastActionDT":1,"OfpFlightStat":"2022-02-25 12:38:33.443","OfpFlightLastError":3,"OfpLastActionDT":1,"OfpFlightVersionCount":"2022-02-25 12:38:33.473","OfpTextStat":3,"OfpTextLastError":1,"OfpTextLastActionDT":"2022-02-25 12:38:33.473","OfpTextVersionCount":3,"OfpFlightReleasePdfStat":1,"OfpFlightReleasePdfLastError":"2022-02-25 12:38:33.473","OfpFlightReleasePdfLastActionDT":3,"OfpFlightReleasePdfVersionCount":1,"MeteoPdfStat":"2022-02-25 12:38:33.490","MeteoPdfLastError":3,"MeteoPdfLastActionDT":1,"MeteoPdfVersionCount":"2022-02-25 12:38:33.570","NotamPdfStat":3,"NotamPdfLastError":1,"NotamPdfLastActionDT":"2022-02-25 12:38:33.570","NotamPdfVersionCount":3,"FuelHeaderStat":1,"FuelHeaderLastError":"2022-02-25 12:38:33.570","FuelHeaderLastActionDT":3,"FuelHeaderVersionCount":1,"WaypointStat":"2022-02-25 13:01:07.903","WaypointLastError":3,"WaypointLastActionDT":1,"WaypointVersionCount":"2022-02-25 13:01:37.183","WeightHeaderStat":3,"WeightHeaderLastError":1,"WeightHeaderLastActionDT":"2022-02-25 13:01:52.690","WeightHeaderVersionCount":3,"WeatherChartStat":1,"WeatherChartLastError":"2022-02-25 13:02:31.393","WeatherChartLastActionDT":3,"WeatherChartVersionCount":9991,"WeatherWebStat":"0x00000001E459F503","WeatherWebLastError":"","WeatherWebLastActionDT":"","WeatherWebVersionCount":"","NotamWebStat":"","NotamWebLastError":"","NotamWebLastActionDT":"","NotamWebVersionCount":"","RaimPredictionStat":"","RaimPredictionLastError":"","RaimPredictionLastActionDT":"","RaimPredictionVersionCount":"","LAST_PLAN_ID_SUCCEED":"","DataVer":""},{"Id":73234,"IDJSummary":21716,"FINAL_TRANS_STAT":1,"FKeyForZip":"TCTJU_CAI5408_20220225_EDLV_LTAI","StartTime":"2022-02-25 12:38:33.397","EndTime":"2022-02-25 12:40:12.670","JLVT":3,"WLVT":2,"IsForcedManually":0,"LastProcess":14,"UnzipStat":1,"UnzipLastError":"2022-02-25 12:38:33.403","UnzipLastActionDT":1,"OfpFlightStat":"2022-02-25 12:38:33.443","OfpFlightLastError":3,"OfpLastActionDT":1,"OfpFlightVersionCount":"2022-02-25 12:38:33.473","OfpTextStat":3,"OfpTextLastError":1,"OfpTextLastActionDT":"2022-02-25 12:38:33.473","OfpTextVersionCount":3,"OfpFlightReleasePdfStat":1,"OfpFlightReleasePdfLastError":"2022-02-25 12:38:33.473","OfpFlightReleasePdfLastActionDT":3,"OfpFlightReleasePdfVersionCount":1,"MeteoPdfStat":"2022-02-25 12:38:33.490","MeteoPdfLastError":3,"MeteoPdfLastActionDT":1,"MeteoPdfVersionCount":"2022-02-25 12:38:33.570","NotamPdfStat":3,"NotamPdfLastError":1,"NotamPdfLastActionDT":"2022-02-25 12:38:33.570","NotamPdfVersionCount":3,"FuelHeaderStat":1,"FuelHeaderLastError":"2022-02-25 12:38:33.570","FuelHeaderLastActionDT":3,"FuelHeaderVersionCount":1,"WaypointStat":"2022-02-25 12:39:07.343","WaypointLastError":2,"WaypointLastActionDT":1,"WaypointVersionCount":"2022-02-25 12:39:09.887","WeightHeaderStat":2,"WeightHeaderLastError":1,"WeightHeaderLastActionDT":"2022-02-25 12:39:24.727","WeightHeaderVersionCount":2,"WeatherChartStat":1,"WeatherChartLastError":"2022-02-25 12:40:03.000","WeatherChartLastActionDT":2,"WeatherChartVersionCount":9991,"WeatherWebStat":"0x00000001E459F503","WeatherWebLastError":"","WeatherWebLastActionDT":"","WeatherWebVersionCount":"","NotamWebStat":"","NotamWebLastError":"","NotamWebLastActionDT":"","NotamWebVersionCount":"","RaimPredictionStat":"","RaimPredictionLastError":"","RaimPredictionLastActionDT":"","RaimPredictionVersionCount":"","LAST_PLAN_ID_SUCCEED":"","DataVer":""},{"Id":73231,"IDJSummary":21716,"FINAL_TRANS_STAT":1,"FKeyForZip":"TCTJU_CAI5408_20220225_EDLV_LTAI","StartTime":"2022-02-25 12:17:49.693","EndTime":"2022-02-25 12:19:40.500","JLVT":2,"WLVT":1,"IsForcedManually":0,"LastProcess":14,"UnzipStat":1,"UnzipLastError":"2022-02-25 12:17:49.703","UnzipLastActionDT":1,"OfpFlightStat":"2022-02-25 12:17:49.710","OfpFlightLastError":2,"OfpLastActionDT":1,"OfpFlightVersionCount":"2022-02-25 12:17:49.740","OfpTextStat":2,"OfpTextLastError":1,"OfpTextLastActionDT":"2022-02-25 12:17:49.740","OfpTextVersionCount":2,"OfpFlightReleasePdfStat":1,"OfpFlightReleasePdfLastError":"2022-02-25 12:17:49.757","OfpFlightReleasePdfLastActionDT":2,"OfpFlightReleasePdfVersionCount":1,"MeteoPdfStat":"2022-02-25 12:17:49.770","MeteoPdfLastError":2,"MeteoPdfLastActionDT":1,"MeteoPdfVersionCount":"2022-02-25 12:17:49.850","NotamPdfStat":2,"NotamPdfLastError":1,"NotamPdfLastActionDT":"2022-02-25 12:17:49.850","NotamPdfVersionCount":2,"FuelHeaderStat":1,"FuelHeaderLastError":"2022-02-25 12:17:49.850","FuelHeaderLastActionDT":2,"FuelHeaderVersionCount":1,"WaypointStat":"2022-02-25 12:18:27.157","WaypointLastError":1,"WaypointLastActionDT":1,"WaypointVersionCount":"2022-02-25 12:18:29.700","WeightHeaderStat":1,"WeightHeaderLastError":1,"WeightHeaderLastActionDT":"2022-02-25 12:18:45.347","WeightHeaderVersionCount":1,"WeatherChartStat":1,"WeatherChartLastError":"2022-02-25 12:19:28.010","WeatherChartLastActionDT":1,"WeatherChartVersionCount":9809,"WeatherWebStat":"0x00000001E441B7E1","WeatherWebLastError":"","WeatherWebLastActionDT":"","WeatherWebVersionCount":"","NotamWebStat":"","NotamWebLastError":"","NotamWebLastActionDT":"","NotamWebVersionCount":"","RaimPredictionStat":"","RaimPredictionLastError":"","RaimPredictionLastActionDT":"","RaimPredictionVersionCount":"","LAST_PLAN_ID_SUCCEED":"","DataVer":""},{"Id":73230,"IDJSummary":21716,"FINAL_TRANS_STAT":2,"FKeyForZip":"TCTJU_CAI5408_20220225_EDLV_LTAI","StartTime":"2022-02-25 12:17:49.280","EndTime":"2022-02-25 12:17:49.437","JLVT":1,"WLVT":0,"IsForcedManually":"NULL","LastProcess":11,"UnzipStat":1,"UnzipLastError":"2022-02-25 12:17:49.280","UnzipLastActionDT":1,"OfpFlightStat":"2022-02-25 12:17:49.313","OfpFlightLastError":1,"OfpLastActionDT":1,"OfpFlightVersionCount":"2022-02-25 12:17:49.343","OfpTextStat":1,"OfpTextLastError":1,"OfpTextLastActionDT":"2022-02-25 12:17:49.343","OfpTextVersionCount":1,"OfpFlightReleasePdfStat":1,"OfpFlightReleasePdfLastError":"2022-02-25 12:17:49.360","OfpFlightReleasePdfLastActionDT":1,"OfpFlightReleasePdfVersionCount":1,"MeteoPdfStat":"2022-02-25 12:17:49.360","MeteoPdfLastError":1,"MeteoPdfLastActionDT":1,"MeteoPdfVersionCount":"2022-02-25 12:17:49.437","NotamPdfStat":1,"NotamPdfLastError":1,"NotamPdfLastActionDT":"2022-02-25 12:17:49.437","NotamPdfVersionCount":1,"FuelHeaderStat":1,"FuelHeaderLastError":"2022-02-25 12:17:49.437","FuelHeaderLastActionDT":1,"FuelHeaderVersionCount":0,"WaypointStat":"1900-01-01 00:00:00.000","WaypointLastError":0,"WaypointLastActionDT":0,"WaypointVersionCount":"1900-01-01 00:00:00.000","WeightHeaderStat":0,"WeightHeaderLastError":0,"WeightHeaderLastActionDT":"1900-01-01 00:00:00.000","WeightHeaderVersionCount":0,"WeatherChartStat":0,"WeatherChartLastError":"1900-01-01 00:00:00.000","WeatherChartLastActionDT":0,"WeatherChartVersionCount":9809,"WeatherWebStat":"0x00000001E441B758a","WeatherWebLastError":"","WeatherWebLastActionDT":"","WeatherWebVersionCount":"","NotamWebStat":"","NotamWebLastError":"","NotamWebLastActionDT":"","NotamWebVersionCount":"","RaimPredictionStat":"","RaimPredictionLastError":"","RaimPredictionLastActionDT":"","RaimPredictionVersionCount":"","LAST_PLAN_ID_SUCCEED":"","DataVer":""}] : (i%3==0)?  "" : "",

                            JsonAttachmentHistory: [],
                            JsonSyncOccHistory:[],
                            JsonJeppesenJetplan:[],

                        })
                    }



            },

            ReturnChangeStatColor(stat)
            {
                if(stat == true)
                {
                    return this.changestatcolor
                }
                else {
                    return ''
                }


            }


        },

       async created()
       {
            this.PageReloadAllData();
           // this.isLoading = true;
           // this.showAllWebStats = true;
           // this.ClearStates();
           //
           //  // bu kısımda keyfornetline ile std bilgisinin alınarak sp de kullanılması gerekmektedir.
           // var keylist = this.FkeyForNetline.split("_");
           // var date = keylist[2];
           //
           // date = date.substring(0,4)+"-"+date.substring(4,6)+"-"+date.substring(6,8)+"T00:00:00";
           //
           // await this.getFlightbyid(this.FkeyForNetline,this.leG_NO,date);
           //
           // await this.getNetlineChangeHistoryByLegNo(this.leG_NO);
           //
           // await this.CalculateChangesOfNetlineChanges();
           //
           //
           // await this.getSummaryVersionsDataByLegno(this.leG_NO);
           //
           // if(!this.flightFolderHistoryWithZip)
           // {
           //     this.isLoading = false;
           //     return;
           // }
           //
           // let data = new Map();
           //
           // for (let obj of this.SummaryVersionsData)
           // {
           //    data.set(obj.jlvt, obj);
           // }
           //
           // this.JLVTDropdownlist = data;
           // this.lastsummary =this.SummaryVersionsData[0];
           //
           // this.SelectedJLVT = this.lastsummary.jlvt;
           // this.SelectedWLVT = this.lastsummary.wlvt;
           //
           // this.forceManuallyControl = this.lastsummary.isForcedManually;
           // this.SelectedJSummaryId = this.lastsummary.idjSummary;
           //
           // this.LoadJLVTlist();
           // // this.loadWLVT();  // zaten jlvt list içinde yüklenme yapılmaktadır.
           //
           // this.htmlContent = this.WRjson_data;
           // this.SearchDate = this.selectedFlight.std.toString().substring(0,10);
           // var ForcedManuallyStat = await HistoryService.GetForceManuallyStat(this.SelectedJSummaryId);
           // this.forceManuallyControl = ForcedManuallyStat;
           // this.isLoading = false;

       }
    }
</script>

<style scoped>

    .btn-excel{
        border: none;
        border-radius: 10px;
        font-size: 15px;
        cursor: pointer;
        height: 30px;
        background-color: #3273dc;
        color: #fff;
        width: 118px;
    }

    .modal-card-size {
        min-height: calc(100vh - 40px);
        min-width: calc(170vh);
    }
    .delete {
        min-height: 20px;
        min-width: 20px;
        max-height: 30px;
        max-width: 30px;
        height: 25px;
        width: 25px;
    }

    tableFixHead table {
        background-color: #f8f6ff!important;
    }

    .modal-netline-th {
        background: #6a85a7;
        color: white;
    }

    .modal-card-head {
        background-color: #f8f6ff!important;
    }
    .modal-card-title{
        color: #6a85a7!important;
    }
    .tableFixHead {
        height: calc(100vh - 150px);
        top: 0;
        width: 100%;
    }

    .tableOverflow {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .mr-10p {
        margin-right: 10px;
    }
    .btn-refresh {
        border: none;
        border-radius: 10px;
        font-size: 15px;
        cursor: pointer;
        min-height: 20px;
        min-width: 20px;
        max-height: 30px;
        max-width: 30px;
        height: 30px;
        width: 30px;
        background-color: #48c78e;
        color: #fff;
    }
    .btn-detail {
        background-color: #f8f6ff;
        color: #6a85a7;
        border: 1px solid #6a85a7;
    }
    .btn-detail:hover {
        background-color: #6a85a7;
        color: #f8f6ff;
    }

    .borderline{
        border-bottom: 3px solid #6184D8;

        text-align: center;
    }

    .borderlineSubtd{
        border-bottom: 3px solid #50C5B7;

        text-align: center;
    }

    .fixed-historic-button{

        min-width: 80px;
        max-width: 80px;
        margin-left: 10px;
    }

    .list-item {
        border-bottom: 0;
        font-family: sans-serif;
        font-style: normal;
        font-size: 15px;
        color: #999999;
        font-weight: bold;
    }

    .request-table-history {
        overflow-y: scroll;
        max-height: 610px;
        font-size: 14px;

    }

    .request-table-history thead {
        background-color: #6a85a7;
        color: whitesmoke;
    }

    .request-table-history th {

        color: whitesmoke;
    }

    .level-item {
        align-items: center;
        display: flex;
        flex-basis: auto;
        flex-grow: 0;
        flex-shrink: 0;
        /* justify-content: center; */
    }

    .section {
        margin-top: -30px;
    }

    .message {
        cursor: pointer;
    }

    .box {
        cursor: pointer;
    }

    .left-main-level {
        display: inline-grid;
        float: left;
        margin-left: 9px;
        margin-bottom: -20px;
        /*margin-bottom: 6px;*/
    }

    .left-lable {
        float: left;
        margin-top: 5px;
    }

    .details-main {
        background-color: whitesmoke;
    }

    .details-label {
        font-size: 11px;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #9e9e9e;
        font-weight: 700;
    }

    .has-background-danger {
        background-color: #ea1111a3 !important;
        color: #4a4a4a;
    }

    .has-background-success {
        background-color: #48c774a8 !important;
        color: #4a4a4a;
    }

    .open-button {
        float: right;
    }

    .close-button {
        float: right;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 12px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .request-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 11px;
        top: -12px;
        position: sticky;
        z-index: 2;

    }

    .request-table td {
        border: 0px;
    }

    .request-table {
        overflow-y: scroll;
        max-height: 630px;
    }

    .request-table th {
        top: -12px;
        positiairports-tableon: sticky;
        background-color: white;
        z-index: 2;
    }

    th {
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    thead  {
        top: -20px;
        position: sticky;
        z-index: 4;

    }

</style>
